"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6198],{

/***/ 36529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Alert = function Alert(_ref) {
  var message = _ref.message,
      _ref$validationId = _ref.validationId,
      validationId = _ref$validationId === void 0 ? "general" : _ref$validationId,
      extraClasses = _ref.extraClasses;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: (0,_utilities__WEBPACK_IMPORTED_MODULE_0__/* .classNames */ .AK)("rounded-md p-1", extraClasses),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "flex items-center gap-1",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "flex-shrink-0"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "text-xs text-red-500",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
          "data-test-id": "".concat(validationId, "-validation-error"),
          children: message
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Alert);

/***/ }),

/***/ 10288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ graphColors; },
/* harmony export */   "$o": function() { return /* binding */ questionDifficulties; },
/* harmony export */   "CR": function() { return /* binding */ preferredPronoun; },
/* harmony export */   "De": function() { return /* binding */ questionTypes; },
/* harmony export */   "Dx": function() { return /* binding */ companyNavigation; },
/* harmony export */   "Eg": function() { return /* binding */ interviewDurationOptions; },
/* harmony export */   "FM": function() { return /* binding */ candidateApplicationMode; },
/* harmony export */   "H4": function() { return /* binding */ homeNavigation; },
/* harmony export */   "HN": function() { return /* binding */ playbackRates; },
/* harmony export */   "K$": function() { return /* binding */ tzStrings; },
/* harmony export */   "LY": function() { return /* binding */ timezones; },
/* harmony export */   "MR": function() { return /* binding */ analyticsEvents; },
/* harmony export */   "MU": function() { return /* binding */ noticePeriodStatuses; },
/* harmony export */   "Nk": function() { return /* binding */ cloudHiring; },
/* harmony export */   "OM": function() { return /* binding */ defaultCurrency; },
/* harmony export */   "OV": function() { return /* binding */ engineerRoles; },
/* harmony export */   "PY": function() { return /* binding */ defaultMarkdownTools; },
/* harmony export */   "Pi": function() { return /* binding */ ContactLinks; },
/* harmony export */   "Qo": function() { return /* binding */ supportedResumeFileMimes; },
/* harmony export */   "S2": function() { return /* binding */ candidateStatus; },
/* harmony export */   "S7": function() { return /* binding */ availabilityStatus; },
/* harmony export */   "S_": function() { return /* binding */ mappedTimeZones; },
/* harmony export */   "So": function() { return /* binding */ educationBackground; },
/* harmony export */   "Su": function() { return /* binding */ hrefRegex; },
/* harmony export */   "Tw": function() { return /* binding */ companyRoles; },
/* harmony export */   "UI": function() { return /* binding */ noticePeriodStrings; },
/* harmony export */   "VD": function() { return /* binding */ roleOptions; },
/* harmony export */   "VO": function() { return /* binding */ candidateApplicationModes; },
/* harmony export */   "Vn": function() { return /* binding */ chartLegendMargin; },
/* harmony export */   "bK": function() { return /* binding */ copyrightText; },
/* harmony export */   "cO": function() { return /* binding */ guestRoutes; },
/* harmony export */   "dA": function() { return /* binding */ sliderCloudEngineers; },
/* harmony export */   "e8": function() { return /* binding */ footerNavigation; },
/* harmony export */   "ew": function() { return /* binding */ questionStatus; },
/* harmony export */   "f$": function() { return /* binding */ engineerNavigation; },
/* harmony export */   "gk": function() { return /* binding */ redactedPlaceholder; },
/* harmony export */   "iK": function() { return /* binding */ interviewerChoiceOptions; },
/* harmony export */   "k8": function() { return /* binding */ noticePeriodStatusesFilter; },
/* harmony export */   "l_": function() { return /* binding */ placeholderColors; },
/* harmony export */   "ln": function() { return /* binding */ candidateUnlockThreshold; },
/* harmony export */   "mI": function() { return /* binding */ workPlaceOptions; },
/* harmony export */   "mk": function() { return /* binding */ infoBannerText; },
/* harmony export */   "nK": function() { return /* binding */ supportedVideoFileMimes; },
/* harmony export */   "p8": function() { return /* binding */ keysToExtract; },
/* harmony export */   "si": function() { return /* binding */ seniorityOptions; },
/* harmony export */   "xH": function() { return /* binding */ englishProficiencyLevel; },
/* harmony export */   "yV": function() { return /* binding */ urlRegex; }
/* harmony export */ });
/* unused harmony exports user_data, uuidValidationRegEx, comments, candidateNavigation, whereDidYourHearAboutUs, whyItemsResponsive, companyWhyItems, companyItemsForResponsiveView, engineeringWhyItems, engineerItemsForResponsiveView, challengesList, challengesEngineers, cloudEngineers */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93024);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59417);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var hrefRegex = /href=/;
var urlRegex = /www\./;
var user_data = {
  name: "Whitney Francis",
  email: "whitney@example.com",
  imageUrl: "https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80"
};
var uuidValidationRegEx = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var ContactLinks = {
  socialMediaLinks: [{
    name: "Facebook",
    link: "https://www.facebook.com/tacnique",
    icon: "/Images/Footer/facebook.png"
  }, {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/tacnique/",
    icon: "/Images/Footer/linkedIn.png"
  }, {
    name: "Instagram",
    link: "https://www.instagram.com/tacnique",
    icon: "/Images/Footer/instagram.png"
  }, {
    name: "YouTube",
    link: "https://www.youtube.com/@tacnique",
    icon: "/Images/Footer/youtube.png"
  }, {
    name: "Twitter",
    link: "https://twitter.com/tacnique",
    icon: "/Images/Footer/x.png"
  }],
  browseLinks: [{
    name: "About Us",
    link: "/about"
  }, {
    name: "Blogs",
    link: "https://blog.tacnique.com"
  } // {
  //     name: "Pricing",
  //     link: "",
  // },
  // {
  //     name: "Contact Us",
  //     link: "",
  // },
  ],
  supportLinks: [{
    name: "Terms of Service",
    link: "/terms-and-conditions"
  }, {
    name: "Privacy Policy",
    link: "/privacy-policy"
  }, {
    name: "Cookies",
    link: "/cookie-policy"
  }]
};
var footerNavigation = {
  solutions: [{
    name: "Marketing",
    href: "#"
  }, {
    name: "Analytics",
    href: "#"
  }, {
    name: "Commerce",
    href: "#"
  }, {
    name: "Insights",
    href: "#"
  }],
  support: [{
    name: "Pricing",
    href: "#"
  }, {
    name: "Documentation",
    href: "#"
  }, {
    name: "Guides",
    href: "#"
  }, {
    name: "API Status",
    href: "#"
  }],
  company: [{
    name: "About",
    href: "#"
  }, {
    name: "Blog",
    href: "#"
  }, {
    name: "Jobs",
    href: "#"
  }, {
    name: "Press",
    href: "#"
  }, {
    name: "Partners",
    href: "#"
  }],
  legal: [{
    name: "Claim",
    href: "#"
  }, {
    name: "Privacy",
    href: "#"
  }, {
    name: "Terms",
    href: "#"
  }],
  social: [{
    name: "Facebook",
    href: "https://www.facebook.com/tacnique",
    icon: function icon(props) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, _objectSpread({
        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faFacebook */ .neY,
        "aria-hidden": "true"
      }, props));
    },
    active: true
  }, {
    name: "Instagram",
    href: "https://www.instagram.com/tacnique",
    icon: function icon(props) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, _objectSpread({
        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faInstagram */ .Zzi,
        "aria-hidden": "true"
      }, props));
    },
    active: true
  }, {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/tacnique/",
    icon: function icon(props) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, _objectSpread({
        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faLinkedin */ .D9H,
        "aria-hidden": "true"
      }, props));
    },
    active: true
  }, {
    name: "Twitter",
    href: "https://twitter.com/tacnique",
    icon: function icon(props) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, _objectSpread({
        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faTwitter */ .mdU,
        "aria-hidden": "true"
      }, props));
    },
    active: true
  }, {
    name: "GitHub",
    href: "#",
    icon: function icon(props) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", _objectSpread(_objectSpread({
        fill: "currentColor",
        viewBox: "0 0 24 24"
      }, props), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
          fillRule: "evenodd",
          d: "M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z",
          clipRule: "evenodd"
        })
      }));
    },
    active: false
  }, {
    name: "YouTube",
    href: "https://www.youtube.com/@tacnique",
    icon: function icon(props) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, _objectSpread({
        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_4__/* .faYoutube */ .opf,
        "aria-hidden": "true"
      }, props));
    },
    active: true
  }]
};
var copyrightText = new Date().getFullYear() + " Tacnique. All Rights Reserved.";
var homeNavigation = [{
  name: "For Companies",
  href: "/",
  links: ["/", "/companies", "/businesses"],
  children: [{
    name: "Verified Talent Pool",
    href: "/companies/verified-talent-pool",
    links: ["/companies/verified-talent-pool"],
    description: "Access screened and interviewed candidates.",
    icon: function icon(props) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, _objectSpread({
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faVideo */ .IyC
      }, props));
    }
  }, {
    name: "Outsource Tech Interview",
    href: "/companies/outsource-tech-interview",
    links: ["/companies/outsource-tech-interview"],
    description: "Conduct technical interviews of candidates.",
    icon: function icon(props) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, _objectSpread({
        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faUsers */ .FVb
      }, props));
    }
  }]
}, {
  name: "For Candidates",
  href: "/engineers",
  links: ["/engineers"]
}, {
  name: "About Us",
  href: "/about",
  links: ["/about"]
}, {
  name: "Blogs",
  href: "https://blog.tacnique.com",
  links: ["https://blog.tacnique.com"]
} // {
//     name: "Pricing",
//     href: "https://blog.tacnique.com",
//     links: ["https://blog.tacnique.com"],
// },
// {
//     name: "Contact Us",
//     href: "https://blog.tacnique.com",
//     links: ["https://blog.tacnique.com"],
// },
];
var companyNavigation = [{
  name: "Dashboard",
  href: "/company/dashboard"
}, {
  name: "Requirements",
  href: "/company/requirements"
}, {
  name: "Candidates",
  href: "/company/candidates"
}, {
  name: "Interviews",
  href: "/company/interviews",
  conditions: ["organization-has-interviewing-platform_access"],
  children: [{
    name: "Question Bank",
    href: "/company/interviews/questions",
    links: ["/company/interviews/questions"]
  }, {
    name: "Interview Design",
    href: "/company/interviews/design",
    links: ["/company/interviews/design"]
  }, {
    name: "Interview Calendar",
    href: "/company/interviews/calendar",
    links: ["/company/interviews/calendar"]
  }, {
    name: "Async Video Interviews",
    href: "/company/interviews/async-video",
    links: ["/company/interviews/async-video"]
  }]
}];
var engineerNavigation = [{
  name: "Profile",
  href: "/engineer/profile"
}, {
  name: "Interviews",
  href: "/engineer/interviews"
} // Disabling offers tab temporarily
// { name: "Offers", href: "/engineer/offers" },
];
var comments = [{
  id: 1,
  name: "Sanjana Gupta",
  date: "4d ago",
  imageId: "1494790108377-be9c29b29330",
  body: "Ducimus quas delectus ad maxime totam doloribus reiciendis ex. Tempore dolorem maiores. Similique voluptatibus tempore non ut."
}, {
  id: 2,
  name: "Manish Jain",
  date: "4d ago",
  imageId: "1519244703995-f4e0f30006d5",
  body: "Et ut autem. Voluptatem eum dolores sint necessitatibus quos. Quis eum qui dolorem accusantium voluptas voluptatem ipsum. Quo facere iusto quia accusamus veniam id explicabo et aut."
}, {
  id: 3,
  name: "Joe Vincent",
  date: "4d ago",
  imageId: "1506794778202-cad84cf45f1d",
  body: "Expedita consequatur sit ea voluptas quo ipsam recusandae. Ab sint et voluptatem repudiandae voluptatem et eveniet. Nihil quas consequatur autem. Perferendis rerum et."
}];
var placeholderColors = ["bg-red-700", "bg-orange-700", "bg-emerald-500", "bg-cyan-600", "bg-blue-500", "bg-fuchsia-600", "bg-pink-500"];
var graphColors = ["#36A2EB", "#FF6384"];
var candidateStatus = {
  all: "All",
  "new": "New",
  screened: "Screened",
  scheduled: "Scheduled",
  interviewed: "Interviewed",
  shortlisted: "Shortlisted",
  hired: "Hired",
  rejected: "Rejected"
};
var tzStrings = [{
  label: "(GMT-12:00) International Date Line West",
  value: "Etc/GMT+12"
}, {
  label: "(GMT-11:00) Midway Island, Samoa",
  value: "Pacific/Midway"
}, {
  label: "(GMT-10:00) Hawaii",
  value: "Pacific/Honolulu"
}, {
  label: "(GMT-09:00) Alaska",
  value: "US/Alaska"
}, {
  label: "(GMT-08:00) Pacific Time (US & Canada)",
  value: "America/Los_Angeles"
}, {
  label: "(GMT-08:00) Tijuana, Baja California",
  value: "America/Tijuana"
}, {
  label: "(GMT-07:00) Arizona",
  value: "US/Arizona"
}, {
  label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
  value: "America/Chihuahua"
}, {
  label: "(GMT-07:00) Mountain Time (US & Canada)",
  value: "US/Mountain"
}, {
  label: "(GMT-06:00) Central America",
  value: "America/Managua"
}, {
  label: "(GMT-06:00) Central Time (US & Canada)",
  value: "US/Central"
}, {
  label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
  value: "America/Mexico_City"
}, {
  label: "(GMT-06:00) Saskatchewan",
  value: "Canada/Saskatchewan"
}, {
  label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
  value: "America/Bogota"
}, {
  label: "(GMT-05:00) Eastern Time (US & Canada)",
  value: "US/Eastern"
}, {
  label: "(GMT-05:00) Indiana (East)",
  value: "US/East-Indiana"
}, {
  label: "(GMT-04:00) Atlantic Time (Canada)",
  value: "Canada/Atlantic"
}, {
  label: "(GMT-04:00) Caracas, La Paz",
  value: "America/Caracas"
}, {
  label: "(GMT-04:00) Manaus",
  value: "America/Manaus"
}, {
  label: "(GMT-04:00) Santiago",
  value: "America/Santiago"
}, {
  label: "(GMT-03:30) Newfoundland",
  value: "Canada/Newfoundland"
}, {
  label: "(GMT-03:00) Brasilia",
  value: "America/Sao_Paulo"
}, {
  label: "(GMT-03:00) Buenos Aires, Georgetown",
  value: "America/Argentina/Buenos_Aires"
}, {
  label: "(GMT-03:00) Greenland",
  value: "America/Godthab"
}, {
  label: "(GMT-03:00) Montevideo",
  value: "America/Montevideo"
}, {
  label: "(GMT-02:00) Mid-Atlantic",
  value: "America/Noronha"
}, {
  label: "(GMT-01:00) Cape Verde Is.",
  value: "Atlantic/Cape_Verde"
}, {
  label: "(GMT-01:00) Azores",
  value: "Atlantic/Azores"
}, {
  label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
  value: "Africa/Casablanca"
}, {
  label: "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
  value: "Etc/Greenwich"
}, {
  label: "(GMT) UTC ",
  value: "UTC"
}, {
  label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  value: "Europe/Amsterdam"
}, {
  label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  value: "Europe/Belgrade"
}, {
  label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
  value: "Europe/Brussels"
}, {
  label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  value: "Europe/Sarajevo"
}, {
  label: "(GMT+01:00) West Central Africa",
  value: "Africa/Lagos"
}, {
  label: "(GMT+02:00) Amman",
  value: "Asia/Amman"
}, {
  label: "(GMT+02:00) Athens, Bucharest, Istanbul",
  value: "Europe/Athens"
}, {
  label: "(GMT+02:00) Beirut",
  value: "Asia/Beirut"
}, {
  label: "(GMT+02:00) Cairo",
  value: "Africa/Cairo"
}, {
  label: "(GMT+02:00) Harare, Pretoria",
  value: "Africa/Harare"
}, {
  label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  value: "Europe/Helsinki"
}, {
  label: "(GMT+02:00) Jerusalem",
  value: "Asia/Jerusalem"
}, {
  label: "(GMT+02:00) Minsk",
  value: "Europe/Minsk"
}, {
  label: "(GMT+02:00) Windhoek",
  value: "Africa/Windhoek"
}, {
  label: "(GMT+03:00) Kuwait, Riyadh, Baghdad",
  value: "Asia/Kuwait"
}, {
  label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
  value: "Europe/Moscow"
}, {
  label: "(GMT+03:00) Nairobi",
  value: "Africa/Nairobi"
}, {
  label: "(GMT+03:00) Tbilisi",
  value: "Asia/Tbilisi"
}, {
  label: "(GMT+03:30) Tehran",
  value: "Asia/Tehran"
}, {
  label: "(GMT+04:00) Abu Dhabi, Muscat",
  value: "Asia/Muscat"
}, {
  label: "(GMT+04:00) Baku",
  value: "Asia/Baku"
}, {
  label: "(GMT+04:00) Yerevan",
  value: "Asia/Yerevan"
}, {
  label: "(GMT+04:30) Kabul",
  value: "Asia/Kabul"
}, {
  label: "(GMT+05:00) Yekaterinburg",
  value: "Asia/Yekaterinburg"
}, {
  label: "(GMT+05:00) Islamabad, Karachi, Tashkent",
  value: "Asia/Karachi"
}, {
  label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  value: "Asia/Kolkata"
}, {
  label: "(GMT+05:30) Sri Jayawardenapura",
  value: "Asia/Calcutta"
}, {
  label: "(GMT+05:45) Kathmandu",
  value: "Asia/Katmandu"
}, {
  label: "(GMT+06:00) Almaty, Novosibirsk",
  value: "Asia/Almaty"
}, {
  label: "(GMT+06:00) Astana, Dhaka",
  value: "Asia/Dhaka"
}, {
  label: "(GMT+06:30) Yangon (Rangoon)",
  value: "Asia/Rangoon"
}, {
  label: "(GMT+07:00) Bangkok, Hanoi, Jakarta",
  value: "Asia/Bangkok"
}, {
  label: "(GMT+07:00) Krasnoyarsk",
  value: "Asia/Krasnoyarsk"
}, {
  label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  value: "Asia/Hong_Kong"
}, {
  label: "(GMT+08:00) Kuala Lumpur, Singapore",
  value: "Asia/Kuala_Lumpur"
}, {
  label: "(GMT+08:00) Irkutsk, Ulaan Bataar",
  value: "Asia/Irkutsk"
}, {
  label: "(GMT+08:00) Perth",
  value: "Australia/Perth"
}, {
  label: "(GMT+08:00) Taipei",
  value: "Asia/Taipei"
}, {
  label: "(GMT+09:00) Osaka, Sapporo, Tokyo",
  value: "Asia/Tokyo"
}, {
  label: "(GMT+09:00) Seoul",
  value: "Asia/Seoul"
}, {
  label: "(GMT+09:00) Yakutsk",
  value: "Asia/Yakutsk"
}, {
  label: "(GMT+09:30) Adelaide",
  value: "Australia/Adelaide"
}, {
  label: "(GMT+09:30) Darwin",
  value: "Australia/Darwin"
}, {
  label: "(GMT+10:00) Brisbane",
  value: "Australia/Brisbane"
}, {
  label: "(GMT+10:00) Canberra, Melbourne, Sydney",
  value: "Australia/Canberra"
}, {
  label: "(GMT+10:00) Hobart",
  value: "Australia/Hobart"
}, {
  label: "(GMT+10:00) Guam, Port Moresby",
  value: "Pacific/Guam"
}, {
  label: "(GMT+10:00) Vladivostok",
  value: "Asia/Vladivostok"
}, {
  label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
  value: "Asia/Magadan"
}, {
  label: "(GMT+12:00) Auckland, Wellington",
  value: "Pacific/Auckland"
}, {
  label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
  value: "Pacific/Fiji"
}, {
  label: "(GMT+13:00) Nuku'alofa",
  value: "Pacific/Tongatapu"
}];
var mappedTimeZones = {
  "Asia/Calcutta": "Asia/Kolkata"
};
var companyRoles = ["org-admin", "interview-scheduler", "interviewer", "client-admin", "client", "ta-manager", "sales-manager"];
var engineerRoles = ["interviewee"];
var seniorityOptions = [{
  value: "ASSOCIATE",
  label: "Associate"
}, {
  value: "JUNIOR",
  label: "Junior"
}, {
  value: "SENIOR",
  label: "Senior"
}, {
  value: "EXPERT",
  label: "Expert"
}, {
  value: "PRINCIPAL",
  label: "Principal"
}, {
  value: "DISTINGUISHED",
  label: "Distinguished"
}];
var workPlaceOptions = [{
  value: "ONSITE",
  label: "Onsite"
}, {
  value: "REMOTE",
  label: "Remote"
}, {
  value: "HYBRID",
  label: "Hybrid"
}];
var analyticsEvents = {
  USER_LOGGED_OUT: "User Logged Out",
  USER_LOGGED_IN: "User Logged In",
  USER_SIGNUP: "User Signed Up",
  PROFILE_UPDATED: "Profile Updated",
  ACCOUNT_UPDATED: "Account Updated",
  DASHBOARD_CHART_CLICKED: "Dashboard Chart Clicked",
  CANDIDATE_ADDED: "Candidate Added",
  CANDIDATE_SHORTLISTED: "Candidate Shortlisted",
  CANDIDATE_HIRED: "Candidate Hired",
  CANDIDATE_REJECTED: "Candidate Rejected",
  REQUIREMENT_CREATED: "Requirement Created",
  REQUIREMENT_CLONED: "Requirement Cloned",
  REQUIREMENT_UPDATED: "Requirement Updated",
  INTERVIEW_RECORDING_PLAYED: "Interview Recording Played",
  CANDIDATE_UPDATED: "Candidate Updated",
  INTERVIEW_CREATED: "Interview Created",
  INTERVIEW_UPDATED: "Interview Updated",
  OPENING_VIEWED: "Opening Viewed",
  OPENING_APPLIED: "Opening Applied",
  USER_SHARE_CREATED: "User Share Created",
  USER_SHARE_ACCEPTED: "User Share Accepted",
  CANDIDATE_UNLOCKED: "Candidate Unlocked",
  ONBOARDING_STEP_COMPLETED: "Onboarding Step Completed",
  ONBOARDING_COMPLETED: "Onboarding Completed",
  ENGINEER_PROFILE_UPDATED: "Engineer Profile Updated"
};
var noticePeriodStatuses = [{
  value: "Yes, I am serving my notice",
  label: "Yes, I am serving my notice"
}, {
  value: "No, I have not resigned yet",
  label: "No, I have not resigned yet"
}, {
  value: "I am not employed currently",
  label: "I am not employed currently"
}];
var noticePeriodStatusesFilter = [{
  value: "Yes, I am serving my notice",
  label: "Serving notice period"
}, {
  value: "No, I have not resigned yet",
  label: "Not resigned yet"
}, {
  value: "I am not employed currently",
  label: "Not employed currently"
}];
var candidateApplicationMode = [{
  value: "All",
  label: "All"
}, {
  value: "Referred",
  label: "Added by you"
}, {
  value: "Registered",
  label: "Applied by Candidate"
}, {
  value: "Sourced",
  label: "Recommended by Tacnique"
}, {
  value: "Shared",
  label: "Shared"
}];
var candidateApplicationModes = ["Referred", "Registered", "Sourced", "Shared"];
var candidateNavigation = (/* unused pure expression or super */ null && (["new", "screened", "scheduled", "interviewed", "rejected", "shortlisted", "hired"]));
var englishProficiencyLevel = [{
  value: "Basic",
  label: "Basic",
  description: "I can only communicate in written form over email or Slack effectively. Verbal communication in English with a engineering manager would be slow and impractical."
}, {
  value: "Average",
  label: "Average",
  description: "I can communicate with a engineering manager if we both speak slowly and occasionally repeat sentences that the other person didn't understand."
}, {
  value: "Great",
  label: "Great",
  description: "Both engineering managers and I can easily understand each other without having to repeat much."
}];
var interviewerChoiceOptions = [{
  value: "in-house",
  label: "In House Interviewers"
}, {
  value: "tacnique",
  label: "Tacnique Experts"
}];
var availabilityStatus = [{
  value: "Actively Looking",
  label: "Actively Looking",
  description: "I am actively looking for a new opportunity. I want to have my master interview ready ASAP so I can apply endlessly."
}, {
  value: "Passively Looking",
  label: "Passively Looking",
  description: "I am not actively looking for a change, but I want to give a master interview so I can keep an eye for new exciting opportunities."
}, {
  value: "Unavailable",
  label: "Unavailable",
  description: "I am happy and getting the growth I desire where I am. So, I am not looking for a new opportunity at the moment."
}];
var preferredPronoun = [{
  value: "he/him",
  label: "He/Him",
  description: "he/him"
}, {
  value: "she/her",
  label: "She/Her",
  description: "she/her"
}, {
  value: "they/them",
  label: "They/Them",
  description: "they/them"
}];
var educationBackground = [{
  value: "Bachelors (or equivalent)",
  label: "Bachelors (or equivalent)"
}, {
  value: "MBA (or equivalent)",
  label: "MBA (or equivalent)"
}, {
  value: "Masters (or equivalent)",
  label: "Masters (or equivalent)"
}, {
  value: "Secondary/High School (or equivalent)",
  label: "Secondary/High School (or equivalent)"
}, {
  value: "Other degree",
  label: "Other degree"
}];
var roleOptions = [{
  value: "client-admin",
  label: "Admin"
}, {
  value: "client",
  label: "Reviewer"
}, {
  value: "interviewer",
  label: "Interviewer"
}]; // Not being used right now

var whereDidYourHearAboutUs = [{
  value: "Received email from Tacnique",
  label: "Received email from Tacnique"
}, {
  value: "Found Tacnique when searching for jobs on Google",
  label: "Found Tacnique when searching for jobs on Google"
}, {
  value: "Facebook ads",
  label: "Facebook ads"
}, {
  value: "Youtube ads",
  label: "Youtube ads"
}, {
  value: "Linkedin / Quora / Twitter / Reddit ads",
  label: "Linkedin / Quora / Twitter / Reddit ads"
}, {
  value: "Billboards / TV / Newspaper ads",
  label: "Billboards / TV / Newspaper ads"
}, {
  value: "Podcast / Music app",
  label: "Podcast / Music app"
}, {
  value: "Online news / 3rd party websites",
  label: "Online news / 3rd party websites"
}, {
  value: "Job posting sites",
  label: "Job posting sites"
}, {
  value: "Referral from a friend /colleague / word of mouth",
  label: "Referral from a friend /colleague / word of mouth"
}, {
  value: "Social media post",
  label: "Social media post"
}, {
  value: "Tacnique Community event",
  label: "Tacnique Community event"
}, {
  value: "Other Events / Conferences",
  label: "Other Events / Conferences"
}, {
  value: "Other",
  label: "Other"
}];
var sliderCloudEngineers = [[{
  icon: "/home/star.svg",
  title: "Top Opportunities",
  desc: "Discover opportunities with the parameters that fit perfectly with your aspiration."
}, {
  icon: "/home/globe.svg",
  title: "Work Anywhere",
  desc: "Apply at your matching organizations worldwide and find the best opportunity for your growth."
}, {
  icon: "/home/detail.svg",
  title: "Job Recommendations",
  desc: "Make your job applications well-informed increasing chances of success."
}], [{
  icon: "/home/quick.svg",
  title: "Quick Turn-around",
  desc: "Avoid coordination delays due to interviewer unavailability or bandwidth shortage."
}, {
  icon: "/home/focus.svg",
  title: "Engineer Focused",
  desc: "Quantify your technical skills and get benchmarked using Tacnique score."
}, {
  icon: "/home/streamlined-process.svg",
  title: "Streamlined Process",
  desc: "Rely on process honed over a decade with a well-defined and role-specific interview process."
}]];
var timezones = ["Africa/Abidjan", "Africa/Accra", "Africa/Addis_Ababa", "Africa/Algiers", "Africa/Asmara", "Africa/Bamako", "Africa/Bangui", "Africa/Banjul", "Africa/Bissau", "Africa/Blantyre", "Africa/Brazzaville", "Africa/Bujumbura", "Africa/Cairo", "Africa/Casablanca", "Africa/Ceuta", "Africa/Conakry", "Africa/Dakar", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Douala", "Africa/El_Aaiun", "Africa/Freetown", "Africa/Gaborone", "Africa/Harare", "Africa/Johannesburg", "Africa/Juba", "Africa/Kampala", "Africa/Khartoum", "Africa/Kigali", "Africa/Kinshasa", "Africa/Lagos", "Africa/Libreville", "Africa/Lome", "Africa/Luanda", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Malabo", "Africa/Maputo", "Africa/Maseru", "Africa/Mbabane", "Africa/Mogadishu", "Africa/Monrovia", "Africa/Nairobi", "Africa/Ndjamena", "Africa/Niamey", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Porto-Novo", "Africa/Sao_Tome", "Africa/Tripoli", "Africa/Tunis", "Africa/Windhoek", "America/Adak", "America/Anchorage", "America/Anguilla", "America/Antigua", "America/Araguaina", "America/Argentina/Buenos_Aires", "America/Argentina/Catamarca", "America/Argentina/Cordoba", "America/Argentina/Jujuy", "America/Argentina/La_Rioja", "America/Argentina/Mendoza", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Aruba", "America/Asuncion", "America/Atikokan", "America/Bahia", "America/Bahia_Banderas", "America/Barbados", "America/Belem", "America/Belize", "America/Blanc-Sablon", "America/Boa_Vista", "America/Bogota", "America/Boise", "America/Cambridge_Bay", "America/Campo_Grande", "America/Cancun", "America/Caracas", "America/Cayenne", "America/Cayman", "America/Chicago", "America/Chihuahua", "America/Costa_Rica", "America/Creston", "America/Cuiaba", "America/Curacao", "America/Danmarkshavn", "America/Dawson", "America/Dawson_Creek", "America/Denver", "America/Detroit", "America/Dominica", "America/Edmonton", "America/Eirunepe", "America/El_Salvador", "America/Fort_Nelson", "America/Fortaleza", "America/Glace_Bay", "America/Goose_Bay", "America/Grand_Turk", "America/Grenada", "America/Guadeloupe", "America/Guatemala", "America/Guayaquil", "America/Guyana", "America/Halifax", "America/Havana", "America/Hermosillo", "America/Indiana/Indianapolis", "America/Indiana/Knox", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Tell_City", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Inuvik", "America/Iqaluit", "America/Jamaica", "America/Juneau", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Kralendijk", "America/La_Paz", "America/Lima", "America/Los_Angeles", "America/Lower_Princes", "America/Maceio", "America/Managua", "America/Manaus", "America/Marigot", "America/Martinique", "America/Matamoros", "America/Mazatlan", "America/Menominee", "America/Merida", "America/Metlakatla", "America/Mexico_City", "America/Miquelon", "America/Moncton", "America/Monterrey", "America/Montevideo", "America/Montserrat", "America/Nassau", "America/New_York", "America/Nipigon", "America/Nome", "America/Noronha", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Nuuk", "America/Ojinaga", "America/Panama", "America/Pangnirtung", "America/Paramaribo", "America/Phoenix", "America/Port-au-Prince", "America/Port_of_Spain", "America/Porto_Velho", "America/Puerto_Rico", "America/Punta_Arenas", "America/Rainy_River", "America/Rankin_Inlet", "America/Recife", "America/Regina", "America/Resolute", "America/Rio_Branco", "America/Santarem", "America/Santiago", "America/Santo_Domingo", "America/Sao_Paulo", "America/Scoresbysund", "America/Sitka", "America/St_Barthelemy", "America/St_Johns", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Swift_Current", "America/Tegucigalpa", "America/Thule", "America/Thunder_Bay", "America/Tijuana", "America/Toronto", "America/Tortola", "America/Vancouver", "America/Whitehorse", "America/Winnipeg", "America/Yakutat", "America/Yellowknife", "Antarctica/Casey", "Antarctica/Davis", "Antarctica/DumontDUrville", "Antarctica/Macquarie", "Antarctica/Mawson", "Antarctica/McMurdo", "Antarctica/Palmer", "Antarctica/Rothera", "Antarctica/Syowa", "Antarctica/Troll", "Antarctica/Vostok", "Arctic/Longyearbyen", "Asia/Aden", "Asia/Almaty", "Asia/Amman", "Asia/Anadyr", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Atyrau", "Asia/Baghdad", "Asia/Bahrain", "Asia/Baku", "Asia/Bangkok", "Asia/Barnaul", "Asia/Beirut", "Asia/Bishkek", "Asia/Brunei", "Asia/Chita", "Asia/Choibalsan", "Asia/Colombo", "Asia/Damascus", "Asia/Dhaka", "Asia/Dili", "Asia/Dubai", "Asia/Dushanbe", "Asia/Famagusta", "Asia/Gaza", "Asia/Hebron", "Asia/Ho_Chi_Minh", "Asia/Hong_Kong", "Asia/Hovd", "Asia/Irkutsk", "Asia/Jakarta", "Asia/Jayapura", "Asia/Jerusalem", "Asia/Kabul", "Asia/Kamchatka", "Asia/Karachi", "Asia/Kathmandu", "Asia/Khandyga", "Asia/Kolkata", "Asia/Krasnoyarsk", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Kuwait", "Asia/Macau", "Asia/Magadan", "Asia/Makassar", "Asia/Manila", "Asia/Muscat", "Asia/Nicosia", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Oral", "Asia/Phnom_Penh", "Asia/Pontianak", "Asia/Pyongyang", "Asia/Qatar", "Asia/Qostanay", "Asia/Qyzylorda", "Asia/Riyadh", "Asia/Sakhalin", "Asia/Samarkand", "Asia/Seoul", "Asia/Shanghai", "Asia/Singapore", "Asia/Srednekolymsk", "Asia/Taipei", "Asia/Tashkent", "Asia/Tbilisi", "Asia/Tehran", "Asia/Thimphu", "Asia/Tokyo", "Asia/Tomsk", "Asia/Ulaanbaatar", "Asia/Urumqi", "Asia/Ust-Nera", "Asia/Vientiane", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yangon", "Asia/Yekaterinburg", "Asia/Yerevan", "Atlantic/Azores", "Atlantic/Bermuda", "Atlantic/Canary", "Atlantic/Cape_Verde", "Atlantic/Faroe", "Atlantic/Madeira", "Atlantic/Reykjavik", "Atlantic/South_Georgia", "Atlantic/St_Helena", "Atlantic/Stanley", "Australia/Adelaide", "Australia/Brisbane", "Australia/Broken_Hill", "Australia/Darwin", "Australia/Eucla", "Australia/Hobart", "Australia/Lindeman", "Australia/Lord_Howe", "Australia/Melbourne", "Australia/Perth", "Australia/Sydney", "Europe/Amsterdam", "Europe/Andorra", "Europe/Astrakhan", "Europe/Athens", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Bucharest", "Europe/Budapest", "Europe/Busingen", "Europe/Chisinau", "Europe/Copenhagen", "Europe/Dublin", "Europe/Gibraltar", "Europe/Guernsey", "Europe/Helsinki", "Europe/Isle_of_Man", "Europe/Istanbul", "Europe/Jersey", "Europe/Kaliningrad", "Europe/Kiev", "Europe/Kirov", "Europe/Lisbon", "Europe/Ljubljana", "Europe/London", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Mariehamn", "Europe/Minsk", "Europe/Monaco", "Europe/Moscow", "Europe/Oslo", "Europe/Paris", "Europe/Podgorica", "Europe/Prague", "Europe/Riga", "Europe/Rome", "Europe/Samara", "Europe/San_Marino", "Europe/Sarajevo", "Europe/Saratov", "Europe/Simferopol", "Europe/Skopje", "Europe/Sofia", "Europe/Stockholm", "Europe/Tallinn", "Europe/Tirane", "Europe/Ulyanovsk", "Europe/Uzhgorod", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Vilnius", "Europe/Volgograd", "Europe/Warsaw", "Europe/Zagreb", "Europe/Zaporozhye", "Europe/Zurich", "Indian/Antananarivo", "Indian/Chagos", "Indian/Christmas", "Indian/Cocos", "Indian/Comoro", "Indian/Kerguelen", "Indian/Mahe", "Indian/Maldives", "Indian/Mauritius", "Indian/Mayotte", "Indian/Reunion", "Pacific/Apia", "Pacific/Auckland", "Pacific/Bougainville", "Pacific/Chatham", "Pacific/Chuuk", "Pacific/Easter", "Pacific/Efate", "Pacific/Fakaofo", "Pacific/Fiji", "Pacific/Funafuti", "Pacific/Galapagos", "Pacific/Gambier", "Pacific/Guadalcanal", "Pacific/Guam", "Pacific/Honolulu", "Pacific/Kanton", "Pacific/Kiritimati", "Pacific/Kosrae", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Marquesas", "Pacific/Midway", "Pacific/Nauru", "Pacific/Niue", "Pacific/Norfolk", "Pacific/Noumea", "Pacific/Pago_Pago", "Pacific/Palau", "Pacific/Pitcairn", "Pacific/Pohnpei", "Pacific/Port_Moresby", "Pacific/Rarotonga", "Pacific/Saipan", "Pacific/Tahiti", "Pacific/Tarawa", "Pacific/Tongatapu", "Pacific/Wake", "Pacific/Wallis", "UTC"];
var defaultCurrency = "INR";
var candidateUnlockThreshold = {
  max: 2,
  min: 0
};
var whyItemsResponsive = [{
  imgSrc: "/home/expert.svg",
  testId: "certified-expert-interviewers",
  title: "Certified Expert Interviewers"
}, {
  imgSrc: "/home/flexible-c.svg",
  testId: "score-based-summary",
  title: "Score-based Summary"
}, {
  imgSrc: "/home/insights.svg",
  testId: "detailed-interview-insights",
  title: "Detailed Interview Insights"
}, {
  imgSrc: "/home/structure.svg",
  testId: "ease-of-access",
  title: "Ease of Access"
}];
var companyWhyItems = [{
  containerClass: "deg45 why",
  innerContainerClass: "p-6 pl-[10px] pl-[10px] rounded-full flex items-top justify-start space-x-6 items-center w-56 lg:w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: true,
  imgSrc: "/home/structure.svg",
  testId: "ease-of-access",
  title: "Ease of Access"
}, {
  containerClass: "deg190 left-position why",
  innerContainerClass: "p-6 pr-[10px] rounded-full flex items-top justify-end space-x-6 items-center w-56 lg:w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: false,
  imgSrc: "/home/culture.svg",
  testId: "ai-video-intelligence",
  title: "AI & Video Intelligence"
}, {
  containerClass: "deg345 why",
  innerContainerClass: "p-6 pl-[10px] rounded-full flex items-top justify-start space-x-6 items-center w-56 lg:w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: true,
  imgSrc: "/home/insights.svg",
  testId: "detailed-interview-insights",
  title: "Detailed Interview Insights"
}, {
  containerClass: "deg225 left-position why",
  innerContainerClass: "p-6 pr-[10px] rounded-full flex items-top justify-end space-x-6 items-center w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: false,
  imgSrc: "/home/video.svg",
  testId: "cloud-interview-recordings",
  title: "Cloud Interview Recordings"
}, {
  containerClass: "deg315 why",
  innerContainerClass: "p-6 pl-[10px] rounded-full flex items-top justify-start space-x-6 items-center w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: true,
  imgSrc: "/home/expert.svg",
  testId: "certified-expert-interviewers",
  title: "Certified Expert Interviewers"
}, {
  containerClass: "deg130 left-position why",
  innerContainerClass: "p-6 pr-[10px] rounded-full flex items-top justify-end space-x-6 items-center w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: false,
  imgSrc: "/home/behaviour.svg",
  testId: "behavioral-assessment",
  title: "Behavioral Assessment"
}, {
  containerClass: "deg160 left-position why",
  innerContainerClass: "p-6 pr-[10px] rounded-full flex items-top justify-end space-x-6 items-center w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: false,
  imgSrc: "/home/stars.svg",
  testId: "technical-skill-assessment",
  title: "Technical Skill Assessment"
}, {
  containerClass: "deg15 why",
  innerContainerClass: "p-6 pl-[10px] rounded-full flex items-top justify-start space-x-6 items-center w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: true,
  imgSrc: "/home/flexible-c.svg",
  testId: "score-based-summary",
  title: "Score-based Summary"
}];
var companyItemsForResponsiveView = [{
  imgSrc: "/home/video.svg",
  testId: "cloud-based-recordings",
  title: "Cloud Interview Recordings"
}, {
  imgSrc: "/home/stars.svg",
  testId: "technical-skill-assessment",
  title: "Technical Skill Assessment"
}, {
  imgSrc: "/home/behaviour.svg",
  testId: "behavioral-assessment",
  title: "Behavioral Assessment"
}, {
  imgSrc: "/home/culture.svg",
  testId: "ai-video-intelligence",
  title: "AI & Video Intelligence"
}];
var engineeringWhyItems = [{
  containerClass: "deg45 why",
  innerContainerClass: "p-6 pl-[10px] pl-[10px] rounded-full flex items-top justify-start space-x-6 items-center w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: true,
  imgSrc: "/home/structure.svg",
  testId: "ease-of-access",
  title: "Ease of Access"
}, {
  containerClass: "deg190 left-position why",
  innerContainerClass: "p-6 pr-[10px] rounded-full flex items-top justify-end space-x-6 items-center w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: false,
  imgSrc: "/home/culture.svg",
  testId: "ai-recommendation-engine",
  title: "AI Recommendation Engine"
}, {
  containerClass: "deg345 why",
  innerContainerClass: "p-6 pl-[10px] rounded-full flex items-top justify-start space-x-6 items-center w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: true,
  imgSrc: "/home/insights.svg",
  testId: "detailed-interview-insights",
  title: "Detailed Interview Insights"
}, {
  containerClass: "deg225 left-position why",
  innerContainerClass: "p-6 pr-[10px] rounded-full flex items-top justify-end space-x-6 items-center w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: false,
  imgSrc: "/home/video.svg",
  testId: "cloud-interview-recordings",
  title: "Cloud Interview Recordings"
}, {
  containerClass: "deg315 why",
  innerContainerClass: "p-6 pl-[10px] rounded-full flex items-top justify-start space-x-6 items-center w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: true,
  imgSrc: "/home/expert.svg",
  testId: "certified-expert-interviewers",
  title: "Certified Expert Interviewers"
}, {
  containerClass: "deg130 left-position why",
  innerContainerClass: "p-6 pr-[10px] rounded-full flex items-top justify-end space-x-6 items-center w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: false,
  imgSrc: "/home/behaviour.svg",
  testId: "behavioral-assessment",
  title: "Behavioral Assessment"
}, {
  containerClass: "deg160 left-position why",
  innerContainerClass: "p-6 pr-[10px] rounded-full flex items-top justify-end space-x-6 items-center w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: false,
  imgSrc: "/home/stars.svg",
  testId: "technical-skill-assessment",
  title: "Technical Skill Assessment"
}, {
  containerClass: "deg15 why",
  innerContainerClass: "p-6 pl-[10px] rounded-full flex items-top justify-start space-x-6 items-center w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
  imageLeft: true,
  imgSrc: "/home/flexible-c.svg",
  testId: "score-based-summary",
  title: "Score-based Summary"
}];
var engineerItemsForResponsiveView = [{
  imgSrc: "/home/video.svg",
  testId: "cloud-based-recordings",
  title: "Cloud Interview Recordings"
}, {
  imgSrc: "/home/stars.svg",
  testId: "technical-skill-assessment",
  title: "Technical Skill Assessment"
}, {
  imgSrc: "/home/behaviour.svg",
  testId: "behavioral-assessment",
  title: "Behavioral Assessment"
}, {
  imgSrc: "/home/culture.svg",
  testId: "ai-recommendation-engine",
  title: "AI Recommendation Engine"
}];
var challengesList = [{
  icon: "/home/time-c.svg",
  title: "49 days invested per hire",
  desc: "People in various roles in the organization spend months before they reach a successful hire.",
  source: "/home/logos_linkedin.svg",
  link: "#"
}, {
  icon: "/home/c-dollar.svg",
  title: "$4000 spent on every hire",
  desc: "The significant amount of bandwidth invested per hire turns into a heavy cost center for a growing business.",
  source: "/home/logos_glassdoor.svg",
  link: "https://www.businessnewsdaily.com/16562-cost-of-hiring-an-employee.html"
}, {
  icon: "/home/c-resume.svg",
  title: "250 applications screened for each hire",
  desc: "The volume of applications coming from various sources frequently overwhelms the hiring teams.",
  source: "/home/logos_glassdoor.svg",
  link: "https://www.glassdoor.com/employers/blog/50-hr-recruiting-stats-make-think/"
}, {
  icon: "/home/c-hour.svg",
  title: "23.7 days taken per interview process",
  desc: "Finding available time between candidates and in-house interviewing engineers results in further delays.",
  source: "/home/logos_glassdoor.svg",
  link: "https://www.bbc.com/worklife/article/20211020-why-hiring-takes-so-long"
}];
var cloudHiring = [{
  icon: "/home/deployed_code_account.svg",
  title: "Technical Interviews by Experts",
  desc: "All interviews are conducted by domain experts with experience building sustainable remote and in-office teams."
}, {
  icon: "/home/psycho.svg",
  title: "Behavioral Analysis",
  desc: "Tacnique’s AI behavioral analysis feature evaluates & analyzes the candidate's behavioral traits to help you find the right fit."
}, {
  icon: "/home/video_cam.svg",
  title: "Tech-enabled Interviews",
  desc: "Our AI tools and recommendation algorithms record the interviews and accurately analyze 16+ customizable parameters."
}, {
  icon: "/home/finance.svg",
  title: "Advanced Reporting and Analytics",
  desc: "Tacnique offers a comprehensive dashboard that provides transparency in the hiring process with around 50+ candidate insights."
}, {
  icon: "/home/person-play.svg",
  title: "Skill Assessment Tools",
  desc: "Add a custom skills test to examine the capabilities. We support 10+ technical skills to get you the best candidates onboard."
}, {
  icon: "/home/partner-exchange.svg",
  title: "Feedbacks For Everybody",
  desc: "Tacnique gives the candidates & hiring teams continuous feedback during and after recruitment for a better hiring experience."
}];
var challengesEngineers = [{
  icon: "/home/time-c.svg",
  title: "10-15 job applications a week for every job hunt",
  desc: "Job hunting for engineers becomes a volume game and requires significant time to find the right opportunity.",
  source: "/home/logos_linkedin.svg",
  link: "https://www.cnbc.com/2021/08/06/these-industries-have-the-slowest-hiring-times-according-to-linkedin-.html0"
}, {
  icon: "/home/c-dollar.svg",
  title: "8-10 hours spent a week on job applications",
  desc: "With a focus on perfecting each application, engineers end up investing countless hours.",
  source: "/home/logos_glassdoor.svg",
  link: "https://www.businessnewsdaily.com/16562-cost-of-hiring-an-employee.html"
}, {
  icon: "/home/c-resume.svg",
  title: "5-10 hours spent in preparation per interview",
  desc: "No standard interview process means repetitive preparation and different expectation to perform.",
  source: "/home/logos_glassdoor.svg",
  link: "https://www.glassdoor.com/employers/blog/50-hr-recruiting-stats-make-think/"
}, {
  icon: "/home/c-hour.svg",
  title: "9% probability of interview turning into offer",
  desc: "You do not know enough to evaluate the opportunity reducing chances of success drastically.",
  source: "/home/logos_glassdoor.svg",
  link: "https://www.bbc.com/worklife/article/20211020-why-hiring-takes-so-long"
}];
var cloudEngineers = [{
  icon: "/home/star.svg",
  title: "Top Opportunities",
  desc: "Discover opportunities with the parameters that fit perfectly with your aspiration."
}, {
  icon: "/home/globe.svg",
  title: "Work Anywhere",
  desc: "Apply at your matching organizations worldwide and find the best opportunity for your growth."
}, {
  icon: "/home/detail.svg",
  title: "Job Recommendations",
  desc: "Make your job applications well-informed increasing chances of success."
}, {
  icon: "/home/quick.svg",
  title: "Quick Turn-around",
  desc: "Avoid coordination delays due to interviewer unavailability or bandwidth shortage."
}, {
  icon: "/home/focus.svg",
  title: "Engineer Focused",
  desc: "Quantify your technical skills and get benchmarked using Tacnique score."
}, {
  icon: "/home/streamlined-process.svg",
  title: "Streamlined Process",
  desc: "Rely on process honed over a decade with a well-defined and role-specific interview process."
}];
var playbackRates = [0.5, 1, 1.25, 1.5, 1.75, 2];
var guestRoutes = ["/", "/404", "/about", "/demo", "/demo/confirmation", "/companies", "/engineers", "/businesses", "/share/[shareCode]", "/companies/outsource-tech-interview", "/companies/verified-talent-pool", "/privacy-policy", "/cookie-policy", "/terms-and-conditions", "/interviews/[interviewUuid]/questions/[questionUuid]", "/interviews/[interviewUuid]/design", "/support", "/zoom-guide"];
var redactedPlaceholder = "****";
var supportedResumeFileMimes = ["application/doc", "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
var supportedVideoFileMimes = ["video/mp4", "video/webm"];
var noticePeriodStrings = {
  "Yes, I am serving my notice": "Serving Notice",
  "No, I have not resigned yet": "Yet To Resign",
  "I am not employed currently": "Not Employed"
};
var infoBannerText = "We are currently inviting engineers with limited number of skills to schedule an interview. Please check back later if you do not see the desired skill.";

var interviewDurationOptions = [{
  value: 30,
  label: 30
}, {
  value: 45,
  label: 45
}, {
  value: 60,
  label: 60
}, {
  value: 75,
  label: 75
}, {
  value: 90,
  label: 90
}];
var questionDifficulties = ["EASY", "MEDIUM", "HARD", "VERY HARD"];
var questionStatus = ["Answered", "Pinned"];
var keysToExtract = ["page", "limit", "requirement_id", "skill_ids", "country_id", "city_id", "notice_period_start", "notice_period_end", "salary_start", "salary_end", "screenedBefore", "screenedAfter", "interviewedBefore", "interviewedAfter", "application_mode", "notice_period_status", "work_place_preference"];
var questionTypes = ["Coding", "Querying", "Knowledge", "Behavioral", "Scenario"];
var chartLegendMargin = {
  id: "legendMargin",
  beforeInit: function beforeInit(chart) {
    var fitValue = chart.legend.fit;

    chart.legend.fit = function fit() {
      fitValue.bind(chart.legend)();
      return this.height += 30;
    };
  }
};
var defaultMarkdownTools = ["bold", "italic", "heading", "|", "quote", "unordered-list", "ordered-list", "|", "image", "table", "|", "code", "horizontal-rule", "|", "undo", "redo", "|", "strikethrough", "|", "fullscreen", "side-by-side", "preview"];

/***/ }),

/***/ 69980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ GET_ALL_ACTIVE_REQUIREMENTS; },
/* harmony export */   "$_": function() { return /* binding */ GET_ALL_COUNTRIES; },
/* harmony export */   "AK": function() { return /* binding */ SEND_EMAIL_VERIFICATION; },
/* harmony export */   "AT": function() { return /* binding */ GET_ALL_ORG_USERS_WITHOUT_ROLE; },
/* harmony export */   "AX": function() { return /* binding */ UPDATE_USER; },
/* harmony export */   "BK": function() { return /* binding */ GET_USERS_BY_IDS; },
/* harmony export */   "C3": function() { return /* binding */ SET_QUESTION_ASKED_AT; },
/* harmony export */   "E4": function() { return /* binding */ GET_CREATE_REQUIREMENT_DATA; },
/* harmony export */   "E_": function() { return /* binding */ GET_ALL_REQUIREMENTS; },
/* harmony export */   "GC": function() { return /* binding */ GET_ALL_QUESTIONS; },
/* harmony export */   "HI": function() { return /* binding */ GET_CANDIDATE_SECONDARY_DETAILS; },
/* harmony export */   "HZ": function() { return /* binding */ CREATE_REQUIREMENT; },
/* harmony export */   "Hn": function() { return /* binding */ GET_ALL_INTERVIEW_TYPES; },
/* harmony export */   "IL": function() { return /* binding */ GET_ALL_ORG_USERS_WITHOUT_ROLE_SEARCHABLE; },
/* harmony export */   "Ik": function() { return /* binding */ GET_CANDIDATE_EDIT_DATA; },
/* harmony export */   "Jm": function() { return /* binding */ GET_PUBLIC_ORGANIZATION; },
/* harmony export */   "KK": function() { return /* binding */ GET_INTERVIEW_QUESTION; },
/* harmony export */   "Lw": function() { return /* binding */ CLONE_REQUIREMENT; },
/* harmony export */   "Mz": function() { return /* binding */ GET_CANDIDATE_FEEDBACKS; },
/* harmony export */   "NQ": function() { return /* binding */ GET_ENGINEER_OFFER_STATISTICS; },
/* harmony export */   "Ny": function() { return /* binding */ GET_CANDIDATE_LIST_DATA; },
/* harmony export */   "Ow": function() { return /* binding */ EDIT_REQUIREMENT; },
/* harmony export */   "P2": function() { return /* binding */ REQUEST_EMAIL_CHANGE; },
/* harmony export */   "PB": function() { return /* binding */ GET_CURRENT_USER; },
/* harmony export */   "PQ": function() { return /* binding */ GET_CANDIDATE; },
/* harmony export */   "PR": function() { return /* binding */ GET_CANDIDATE_PII_DATA; },
/* harmony export */   "PY": function() { return /* binding */ DELETE_INTERVIEW_RECORDING; },
/* harmony export */   "Q2": function() { return /* binding */ GET_EDIT_REQUIREMENT_DATA; },
/* harmony export */   "Qw": function() { return /* binding */ ADD_QUESTION; },
/* harmony export */   "Rw": function() { return /* binding */ ORG_INTERVIEWER_SLOTS; },
/* harmony export */   "Rz": function() { return /* binding */ GET_QUESTION; },
/* harmony export */   "SN": function() { return /* binding */ UPDATE_CANDIDATE; },
/* harmony export */   "T2": function() { return /* binding */ GET_ALL_REQUIREMENT_COUNT; },
/* harmony export */   "Tn": function() { return /* binding */ UPLOAD_AND_PARSE_RESUMES; },
/* harmony export */   "UC": function() { return /* binding */ TOGGLE_USER_ACTIVE_STATE; },
/* harmony export */   "UN": function() { return /* binding */ EDIT_QUESTION; },
/* harmony export */   "VE": function() { return /* binding */ GENERATE_PRESIGNED_UPLOAD_URLS; },
/* harmony export */   "VK": function() { return /* binding */ SHARE_ENGINEER_PROFILE; },
/* harmony export */   "Wp": function() { return /* binding */ GET_REQUIREMENTS_BY_ACTIVE_STATE; },
/* harmony export */   "X8": function() { return /* binding */ GET_INSIGHTS_BY_QUESTION_TYPE; },
/* harmony export */   "XO": function() { return /* binding */ GET_ALL_CANDIDATE_REQUIREMENTS; },
/* harmony export */   "YC": function() { return /* binding */ GET_CANDIDATE_REQUIREMENT_LIST_DATA; },
/* harmony export */   "Yg": function() { return /* binding */ VALIDATE_GOOGLE_TOKEN; },
/* harmony export */   "_t": function() { return /* binding */ GET_DASHBOARD_REQUIREMENT_COUNT_DATA; },
/* harmony export */   "_v": function() { return /* binding */ GET_PROFILE_DATA; },
/* harmony export */   "a_": function() { return /* binding */ CREATE_BULK_CANDIDATES; },
/* harmony export */   "at": function() { return /* binding */ REMOVE_RESUME; },
/* harmony export */   "bA": function() { return /* binding */ GET_QUESTIONS_LIST_DATA; },
/* harmony export */   "bI": function() { return /* binding */ GET_CITIES_VIA_COUNTRY; },
/* harmony export */   "bp": function() { return /* binding */ GET_CLIENT_NOTIFICATION_TYPES; },
/* harmony export */   "cA": function() { return /* binding */ GET_CANDIDATE_CALL_RECORD; },
/* harmony export */   "cj": function() { return /* binding */ GET_ALL_ORG_USERS_WITH_ROLE; },
/* harmony export */   "cw": function() { return /* binding */ GET_CANDIDATE_NEXT_PREVIOUS; },
/* harmony export */   "dY": function() { return /* binding */ SCHEDULE_CANDIDATE_INTERVIEW; },
/* harmony export */   "dv": function() { return /* binding */ GET_ALL_SKILLS; },
/* harmony export */   "e7": function() { return /* binding */ CLONE_QUESTION; },
/* harmony export */   "e_": function() { return /* binding */ GET_ORGANIZATION; },
/* harmony export */   "gd": function() { return /* binding */ GET_ALL_FILTERED_REQUIREMENTS; },
/* harmony export */   "gz": function() { return /* binding */ STORE_CANDIDATE_FEEDBACK_STATUS; },
/* harmony export */   "i7": function() { return /* binding */ GET_ORGANIZATION_WITH_USERS; },
/* harmony export */   "iE": function() { return /* binding */ GET_CANDIDATE_SKILL_DATA; },
/* harmony export */   "jl": function() { return /* binding */ UPDATE_INTERVIEW_DETAILS; },
/* harmony export */   "kJ": function() { return /* binding */ GET_CANDIDATES; },
/* harmony export */   "lp": function() { return /* binding */ SCHEDULE_INTERVIEW; },
/* harmony export */   "m8": function() { return /* binding */ GET_QUESTION_GROUPS_BY_QUESTION_SKILL; },
/* harmony export */   "mI": function() { return /* binding */ SHARE_CANDIDATE; },
/* harmony export */   "mM": function() { return /* binding */ RESCHEDULE_INTERVIEW; },
/* harmony export */   "nC": function() { return /* binding */ GET_ENGINEER_USER_INTERVIEWS; },
/* harmony export */   "nn": function() { return /* binding */ INITIATE_CALL; },
/* harmony export */   "nr": function() { return /* binding */ ONBOARDING_STATUS; },
/* harmony export */   "oj": function() { return /* binding */ CHANGE_PASSWORD; },
/* harmony export */   "pX": function() { return /* binding */ GET_ALL_USERS_WITHOUT_ROLE; },
/* harmony export */   "qK": function() { return /* binding */ CREATE_USER; },
/* harmony export */   "qQ": function() { return /* binding */ CREATE_REFERRED_CANDIDATE; },
/* harmony export */   "qV": function() { return /* binding */ GET_INSIGHT_GROUPS_BY_INTERVIEW_TYPE; },
/* harmony export */   "qn": function() { return /* binding */ GET_SAMPLE_INTERVIEW_DESIGN; },
/* harmony export */   "rA": function() { return /* binding */ PUBLISH_QUESTION; },
/* harmony export */   "rt": function() { return /* binding */ GET_CANDIDATE_STATIC_DATA; },
/* harmony export */   "sT": function() { return /* binding */ GET_DASHBOARD_CANDIDATE_STATISTICS; },
/* harmony export */   "tC": function() { return /* binding */ TOGGLE_REQUIREMENT_ACTIVE_STATE; },
/* harmony export */   "th": function() { return /* binding */ GET_INTERVIEW_DATA; },
/* harmony export */   "tx": function() { return /* binding */ ORG_INTERVIEW_TYPES; },
/* harmony export */   "uc": function() { return /* binding */ GET_CALENDAR_INTERVIEWS; },
/* harmony export */   "v_": function() { return /* binding */ GET_ALL_INSIGHTS_PAGINATED; },
/* harmony export */   "xD": function() { return /* binding */ GET_ASYNC_MEET_ACCESS; },
/* harmony export */   "xH": function() { return /* binding */ UNLOCK_CANDIDATE; },
/* harmony export */   "xl": function() { return /* binding */ EDIT_REFERRED_CANDIDATE; },
/* harmony export */   "xv": function() { return /* binding */ GET_INTERVIEW_DESIGN; },
/* harmony export */   "yH": function() { return /* binding */ SAVE_SHARED_ENGINEER_PROFILE; },
/* harmony export */   "yI": function() { return /* binding */ GET_CANDIDATE_STATISTICS; },
/* harmony export */   "yS": function() { return /* binding */ UPDATE_CANDIDATE_FEEDBACK_STATUS; },
/* harmony export */   "ye": function() { return /* binding */ GET_CANDIDATE_DETAILS; },
/* harmony export */   "z2": function() { return /* binding */ GET_DASHBOARD_REQUIREMENTS_CHART_DATA; },
/* harmony export */   "z7": function() { return /* binding */ GET_REQUIREMENT; },
/* harmony export */   "zM": function() { return /* binding */ GET_CANDIDATE_INTERVIEWS; },
/* harmony export */   "zd": function() { return /* binding */ GET_CANDIDATE_SKILLS; },
/* harmony export */   "zh": function() { return /* binding */ UPDATE_ORGANIZATION; }
/* harmony export */ });
/* unused harmony exports APPLY_OPENING, UPDATE_USER_WITH_PARSED_DETAILS, GET_REQUIREMENTS_QUERY, GET_CANDIDATE_CREATE_DATA, GET_CANDIDATE_EDIT_STATIC_DATA */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31230);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102;


var GET_CURRENT_USER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query currentUser {\n        currentUser {\n            id\n            name\n            email\n            email_verified_at\n            phone\n            years_of_experience\n            notice_period\n            notice_period_status\n            current_compensation\n            expected_compensation\n            current_compensation_text\n            expected_compensation_text\n            years_of_remote_experience\n            async_video_intro_link\n            english_proficiency_level\n            availability_status\n            preferred_pronoun\n            heard_from\n            number_of_completed_given_interviews\n            education_details {\n                id\n                has_degree\n                has_degree_in\n                college\n                start_period\n                end_period\n            }\n            work_experiences {\n                id\n                company\n                job_role\n                start_period\n                end_period\n                description\n                is_currently_working_here\n            }\n            is_email_change_requested\n            resume_url\n            resume_mime\n            roles {\n                id\n                name\n            }\n            organization {\n                id\n                name\n                country {\n                    id\n                    name\n                }\n            }\n            skills {\n                id\n                name\n                user_pivot {\n                    years_of_experience\n                    rating\n                }\n            }\n            country {\n                id\n                name\n                currency_suffix\n            }\n            city {\n                id\n                name\n            }\n            citizenship_country {\n                id\n                name\n            }\n            timezone\n            notification_types {\n                id\n                event\n                event_group\n                pivot {\n                    status\n                }\n            }\n            application_uuids\n        }\n    }\n"])));
var GET_CANDIDATE_STATISTICS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query candidateStatistics {\n        candidateStatistics {\n            total_candidates\n            new_candidates\n            shortlisted_candidates\n            hired_candidates\n            rejected_candidates\n            screened_candidates\n            interviewed_candidates\n            scheduled_candidates\n        }\n    }\n"])));
var GET_ENGINEER_OFFER_STATISTICS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query engineerOfferStatistics {\n        engineerOfferStatistics {\n            pending_offers\n            rejected_offers\n            accepted_offers\n        }\n    }\n"])));
var GET_ENGINEER_USER_INTERVIEWS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getEngineerUser($id: ID!) {\n        user(id: $id) {\n            application_interviews {\n                id\n                duration\n                scheduler {\n                    id\n                    organization {\n                        id\n                    }\n                }\n                interview_details {\n                    insight_group_collection\n                    recording_urls\n                    scores\n                    skill_scores\n                    short_recording_urls\n                    strengths\n                    weaknesses\n                    locked\n                    details_pending\n                    transcript_analysis\n                    transcript_urls\n                    recommendation\n                    score\n                    has_hire_recommendation\n                    has_no_hire_recommendation\n                }\n                organization {\n                    id\n                    name\n                }\n                candidate {\n                    is_referred\n                }\n                interviewer {\n                    id\n                    name\n                    email\n                    interview_count\n                    organization {\n                        id\n                    }\n                }\n                participant {\n                    id\n                    name\n                }\n                start_time\n                interview_type {\n                    id\n                    name\n                }\n                skills {\n                    id\n                    name\n                    interview_pivot {\n                        recommendation\n                    }\n                }\n                started_at\n                meeting_url\n                invalidation_reasons\n                is_published\n            }\n            application_openings {\n                name\n            }\n        }\n    }\n"])));
var GET_CANDIDATE_SKILLS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidate($uuid: String!) {\n        candidate(uuid: $uuid) {\n            id\n            uuid\n            skills {\n                id\n                name\n                pivot {\n                    years_of_experience\n                }\n            }\n            certifications {\n                id\n                name\n                pivot {\n                    certification_url\n                    comments\n                }\n            }\n        }\n    }\n"])));
var GET_CANDIDATE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidate($uuid: String!) {\n        candidate(uuid: $uuid) {\n            id\n            uuid\n            pii {\n                name\n                email\n                phone\n            }\n            pii_docs {\n                resume\n                resume_url\n                resume_mime\n            }\n            application_mode\n            created_at\n            years_of_experience\n            years_of_remote_experience\n            notice_period\n            notice_period_status\n            current_compensation\n            expected_compensation\n            current_compensation_text\n            expected_compensation_text\n            has_references_requested\n            remaining_notice_period\n            github_username\n            preferred_cities {\n                name\n            }\n            holding_compensation_text\n            negotiable_compensation_text\n            negotiable_compensation\n            negotiable_compensation_status\n            holding_compensation\n            applied_for\n            work_preferences\n            challenging_work\n            worklife_goals\n            reason_for_change\n            requires_unlocking\n            gravatar\n            screening_status\n            screening_status_hint\n            screening_notes\n            last_screened_at\n            rejection_reasons\n            english_proficiency_level\n            experience_areas\n            work_place_preference\n            last_working_day\n            communication_screening\n            education_details {\n                id\n                has_degree\n                has_degree_in\n                college\n                start_period\n                end_period\n            }\n            organization {\n                id\n            }\n            previous {\n                status\n                all\n            }\n            next {\n                status\n                all\n            }\n            async_video_intro_link\n            openings {\n                name\n            }\n            city {\n                id\n                name\n            }\n            country {\n                id\n                name\n                currency\n            }\n            interviews {\n                id\n                duration\n                scheduler {\n                    id\n                    organization {\n                        id\n                    }\n                }\n                interview_details(candidate_uuid: $uuid) {\n                    insight_group_collection\n                    recording_urls\n                    scores\n                    skill_scores\n                    short_recording_urls\n                    strengths\n                    weaknesses\n                    locked\n                    details_pending\n                    transcript_analysis\n                    transcript_urls\n                    recommendation\n                    score\n                    has_hire_recommendation\n                    has_no_hire_recommendation\n                }\n                organization {\n                    id\n                    name\n                }\n                candidate {\n                    is_referred\n                }\n                interviewer {\n                    id\n                    name\n                    email\n                    interview_count\n                    about_me\n                    profile_picture\n                    organization {\n                        id\n                    }\n                }\n                participant {\n                    id\n                    name\n                }\n                start_time\n                interview_type {\n                    id\n                    name\n                }\n                skills {\n                    id\n                    name\n                    interview_pivot {\n                        recommendation\n                    }\n                }\n                started_at\n                meeting_url\n                invalidation_reasons\n            }\n            skills {\n                id\n                name\n                pivot {\n                    years_of_experience\n                }\n            }\n            meta {\n                type\n                key\n                value\n            }\n            requirements {\n                id\n                name\n            }\n            feedbacks {\n                id\n                user {\n                    id\n                    name\n                }\n                requirement {\n                    id\n                    name\n                }\n                status\n                comments\n            }\n            call_logs_around_screened_at {\n                call_recording_url\n            }\n        }\n    }\n"])));
var GET_CANDIDATE_DETAILS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidate($uuid: String!) {\n        candidate(uuid: $uuid) {\n            id\n            pii {\n                name\n                email\n                phone\n            }\n            pii_docs {\n                resume\n                resume_url\n                resume_mime\n            }\n            uuid\n            application_mode\n            created_at\n            years_of_experience\n            years_of_remote_experience\n            notice_period\n            notice_period_status\n            current_compensation\n            expected_compensation\n            current_compensation_text\n            expected_compensation_text\n            has_references_requested\n            remaining_notice_period\n            github_username\n            linkedin_profile_url\n            preferred_cities {\n                name\n            }\n            holding_compensation_text\n            negotiable_compensation_text\n            negotiable_compensation\n            negotiable_compensation_status\n            holding_compensation\n            applied_for\n            work_preferences\n            challenging_work\n            worklife_goals\n            reason_for_change\n            requires_unlocking\n            gravatar\n            screening_status\n            screening_status_hint\n            screening_notes\n            last_screened_at\n            screened_by {\n                name\n            }\n            rejection_reasons\n            english_proficiency_level\n            experience_areas\n            work_place_preference\n            last_working_day\n            communication_screening\n            internal_notes\n            education_details {\n                id\n                has_degree\n                has_degree_in\n                college\n                start_period\n                end_period\n            }\n            organization {\n                id\n            }\n            async_video_intro_link\n            async_video_interviews {\n                uuid\n                title\n                created_at\n                link\n            }\n            openings {\n                name\n            }\n            city {\n                id\n                name\n            }\n            country {\n                id\n                name\n                currency\n            }\n            meta {\n                type\n                key\n                value\n            }\n            feedbacks {\n                id\n                user {\n                    id\n                    name\n                }\n                requirement {\n                    id\n                    name\n                    organization {\n                        id\n                        name\n                    }\n                }\n                status\n                comments\n                amount\n                notify_candidate\n                country {\n                    id\n                    name\n                    currency\n                    currency_suffix\n                }\n            }\n            requirements {\n                id\n                name\n                organization {\n                    id\n                    name\n                }\n            }\n            reviewers {\n                id\n                name\n                email\n            }\n            comments {\n                id\n                user {\n                    id\n                    name\n                    profile_picture\n                }\n                comment\n                created_at\n                updated_at\n            }\n            assessments {\n                id\n                uuid\n                is_published\n                submission_links {\n                    link\n                    title\n                }\n                submission_notes\n                created_at\n                assessment_type {\n                    id\n                    name\n                    link\n                    deadline\n                    duration\n                    attempts\n                    instructions\n                }\n                comments {\n                    id\n                    user {\n                        id\n                        name\n                        profile_picture\n                    }\n                    comment\n                    created_at\n                    updated_at\n                }\n            }\n        }\n    }\n"])));
var GET_CANDIDATE_NEXT_PREVIOUS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject8 || (_templateObject8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidate($uuid: String!) {\n        candidate(uuid: $uuid) {\n            id\n            previous {\n                status\n                all\n            }\n            next {\n                status\n                all\n            }\n        }\n    }\n"])));
var GET_CANDIDATE_INTERVIEWS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject9 || (_templateObject9 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidate($uuid: String!) {\n        candidate(uuid: $uuid) {\n            interviews {\n                uuid\n                id\n                duration\n                scheduler {\n                    name\n                    id\n                    organization {\n                        id\n                    }\n                }\n                interview_details(candidate_uuid: $uuid) {\n                    insight_group_collection\n                    recording_urls\n                    scores\n                    skill_scores\n                    short_recording_urls\n                    strengths\n                    weaknesses\n                    locked\n                    details_pending\n                    transcript_analysis\n                    transcript_urls\n                    chat_urls\n                    recommendation\n                    score\n                    has_hire_recommendation\n                    has_no_hire_recommendation\n                    internal_notes\n                }\n                organization {\n                    id\n                    name\n                }\n                candidate {\n                    is_referred\n                }\n                interviewer {\n                    id\n                    name\n                    email\n                    interview_count\n                    about_me\n                    profile_picture\n                    organization {\n                        id\n                    }\n                }\n                participant {\n                    id\n                    name\n                    email\n                }\n                start_time\n                interview_type {\n                    id\n                    name\n                }\n                skills {\n                    id\n                    name\n                    interview_pivot {\n                        recommendation\n                    }\n                }\n                started_at\n                meeting_url\n                invalidation_reasons\n                is_private\n                comments {\n                    id\n                    user {\n                        id\n                        name\n                    }\n                    comment\n                    created_at\n                }\n            }\n        }\n    }\n"])));
var GET_CANDIDATE_CALL_RECORD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject10 || (_templateObject10 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidate($uuid: String!) {\n        candidate(uuid: $uuid) {\n            call_logs_around_screened_at {\n                call_recording_url\n                start_time\n            }\n            whatsapp_bot_texts {\n                reduced_payload\n                event_type\n                created_at\n            }\n        }\n    }\n"])));
var GET_CANDIDATES = function GET_CANDIDATES(searchName, searchEmail, filterNoticePeriod, filterSalary) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject11 || (_templateObject11 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidates(\n        $first: Int!\n        $page: Int!\n        $hasRequirement: ID\n        $hasSkills: [ID]\n        $screened: DateRangeInput\n        $interviewed: DateRangeInput\n        $statusFiltered: String!\n        $application_mode: String\n        $work_place_preference: [String]\n        $notice_period_status: String\n        ", "\n        ", "\n        ", "\n        ", "\n        $country_id: String\n        $city_id: String\n        ", "\n        ", "\n    ) {\n        candidates(\n            first: $first\n            page: $page\n            hasRequirement: $hasRequirement\n            hasSkills: $hasSkills\n            screened: $screened\n            interviewed: $interviewed\n            statusFiltered: $statusFiltered\n            application_mode: $application_mode\n            work_place_preference: $work_place_preference\n            notice_period_status: $notice_period_status\n            country_id: $country_id\n            city_id: $city_id\n            where: {\n                OR: [\n                    ", "\n                    ", "\n\n                ]\n                AND: [\n                    ", "\n                    ", "\n                ]\n            }\n        ) {\n        data {\n                id\n                uuid\n                pii {\n                    name\n                    email\n                }\n                pii_docs {\n                    resume\n                    resume_url\n                    resume_mime\n                }\n                created_at\n                years_of_experience\n                notice_period\n                notice_period_status\n                current_compensation\n                expected_compensation\n                expected_compensation_text\n                async_video_intro_link\n                remaining_notice_period\n                gravatar\n                application_mode\n                work_place_preference\n                interviews {\n                id\n                start_time\n                }\n                feedbacks {\n                    id\n                    user {\n                        id\n                        name\n                    }\n                    requirement {\n                        id\n                        name\n                        organization {\n                        id\n                        name\n                    }\n                    }\n                    status\n                    comments\n                    notify_candidate\n                    country {\n                        id\n                        name\n                        currency\n                        currency_suffix\n                    }\n                    amount\n                }\n                requirements {\n                    id\n                    name\n                    organization {\n                        id\n                        name\n                    }\n                }\n                organization {\n                    id\n                }\n                city {\n                    name\n                }\n                country {\n                    name\n                }\n            }\n            paginatorInfo {\n                count\n                currentPage\n                firstItem\n                hasMorePages\n                lastItem\n                lastPage\n                total\n            }\n    }\n}"])), filterNoticePeriod ? "$notice_period_start: Mixed" : "", filterNoticePeriod ? "$notice_period_end: Mixed" : "", filterSalary ? "$salary_start: Mixed" : "", filterSalary ? "$salary_end: Mixed" : "", searchName ? "$searchName: Mixed" : "", searchEmail ? "$searchEmail: Mixed" : "", searchName ? "{ column: NAME, operator: ILIKE, value: $searchName }" : "", searchEmail ? "{ column: EMAIL, operator: ILIKE, value: $searchEmail }" : "", filterNoticePeriod ? "{ column: NOTICE_PERIOD, operator: GTE, value: $notice_period_start }, { column: NOTICE_PERIOD, operator: LTE, value: $notice_period_end }" : "", filterSalary ? "{ column: EXPECTED_COMPENSATION, operator: GTE, value: $salary_start }, { column: EXPECTED_COMPENSATION, operator: LTE, value: $salary_end }" : "");
};
var GET_CANDIDATE_SECONDARY_DETAILS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject12 || (_templateObject12 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query candidateSecondaryDetails($uuids: Mixed) {\n        candidateSecondaryDetails(\n            where: { column: UUID, value: $uuids, operator: IN }\n        ) {\n            uuid\n            skills {\n                name\n                pivot {\n                    years_of_experience\n                }\n            }\n            interviews_count\n            requires_unlocking\n            has_passed_screening\n            has_failed_screening\n            has_hire_recommendation\n            has_no_hire_recommendation\n            last_completed_at\n        }\n    }\n"])));
var GET_ORGANIZATION_WITH_USERS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject13 || (_templateObject13 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getOrganization($id: ID!) {\n        organization(id: $id) {\n            id\n            name\n            logo\n            brand_color\n            client_users {\n                id\n                name\n                phone\n                email\n                is_active\n                timezone\n                profile_picture\n                roles {\n                    name\n                }\n            }\n        }\n    }\n"])));
var GET_ALL_ORG_USERS_WITH_ROLE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject14 || (_templateObject14 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query allUsers($roles: [String], $organization_id: Mixed) {\n        allUsers(\n            hasRoles: $roles\n            where: {\n                column: ORGANIZATION_ID\n                operator: EQ\n                value: $organization_id\n            }\n        ) {\n            id\n            name\n            email\n            roles {\n                id\n            }\n        }\n    }\n"])));
var GET_ALL_ORG_USERS_WITHOUT_ROLE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject15 || (_templateObject15 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query allUsers(\n        $roles: [String]\n        $organization_id: Mixed\n        $is_unavailable_for_interviewing: Mixed\n    ) {\n        allUsers(\n            hasRoles: $roles\n            where: {\n                AND: [\n                    {\n                        column: ORGANIZATION_ID\n                        operator: EQ\n                        value: $organization_id\n                    }\n                    {\n                        column: IS_UNAVAILABLE_FOR_INTERVIEWING\n                        operator: EQ\n                        value: $is_unavailable_for_interviewing\n                    }\n                ]\n            }\n        ) {\n            id\n            name\n            email\n            roles {\n                id\n            }\n        }\n    }\n"])));
var GET_ALL_ORG_USERS_WITHOUT_ROLE_SEARCHABLE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject16 || (_templateObject16 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query allUsers(\n        $roles: [String]\n        $organization_id: Mixed\n        $is_unavailable_for_interviewing: Mixed\n        $search: Mixed\n    ) {\n        allUsers(\n            hasRoles: $roles\n            where: {\n                AND: [\n                    {\n                        column: ORGANIZATION_ID\n                        operator: EQ\n                        value: $organization_id\n                    }\n                    {\n                        column: IS_UNAVAILABLE_FOR_INTERVIEWING\n                        operator: EQ\n                        value: $is_unavailable_for_interviewing\n                    }\n                    {\n                        OR: [\n                            { column: NAME, operator: LIKE, value: $search }\n                            { column: EMAIL, operator: LIKE, value: $search }\n                        ]\n                    }\n                ]\n            }\n        ) {\n            id\n            name\n            email\n            roles {\n                id\n            }\n        }\n    }\n"])));
var GET_USERS_BY_IDS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject17 || (_templateObject17 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query allUsers($user_ids: Mixed!) {\n        allUsers(where: { column: ID, operator: IN, value: $user_ids }) {\n            id\n            name\n            email\n            roles {\n                id\n            }\n        }\n    }\n"])));
var GET_ALL_USERS_WITHOUT_ROLE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject18 || (_templateObject18 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query allUsers(\n        $roles: [String]\n        $searchName: Mixed\n        $searchEmail: Mixed\n        $organizationId: Mixed\n    ) {\n        allUsers(\n            hasRoles: $roles\n            where: {\n                AND: {\n                    column: ORGANIZATION_ID\n                    operator: EQ\n                    value: $organizationId\n                }\n                OR: [\n                    { column: NAME, operator: ILIKE, value: $searchName }\n                    { column: EMAIL, operator: ILIKE, value: $searchEmail }\n                ]\n            }\n        ) {\n            id\n            name\n            email\n            roles {\n                id\n            }\n        }\n    }\n"])));
var GET_ORGANIZATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject19 || (_templateObject19 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query organization($id: ID!) {\n        organization(id: $id) {\n            id\n            name\n            logo\n            credits_remaining\n            country {\n                currency\n                currency_suffix\n                name\n                id\n            }\n        }\n    }\n"])));
var GET_PUBLIC_ORGANIZATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject20 || (_templateObject20 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query publicOrganization($referral_code: String) {\n        publicOrganization(referral_code: $referral_code) {\n            name\n            logo\n            brand_color\n        }\n    }\n"])));
var ONBOARDING_STATUS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject21 || (_templateObject21 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation updateUserOnboarding($data: UserOnboardingInput!) {\n        updateUserOnboarding(data: $data) {\n            id\n            is_onboarding_completed\n        }\n    }\n"])));
var CREATE_REFERRED_CANDIDATE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject22 || (_templateObject22 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation storeReferredCandidate($data: CandidateInput!) {\n        storeReferredCandidate(data: $data) {\n            id\n        }\n    }\n"])));
var EDIT_REFERRED_CANDIDATE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject23 || (_templateObject23 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation editReferredCandidate($data: CandidateInput!) {\n        editReferredCandidate(data: $data) {\n            id\n            uuid\n        }\n    }\n"])));
var CREATE_REQUIREMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject24 || (_templateObject24 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation storeRequirement($data: RequirementInput!) {\n        storeRequirement(data: $data) {\n            id\n            name\n            work_place\n        }\n    }\n"])));
var CHANGE_PASSWORD = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject25 || (_templateObject25 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation changePasswordRequest($data: ChangePasswordInput!) {\n        changePasswordRequest(data: $data)\n    }\n"])));
var EDIT_REQUIREMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject26 || (_templateObject26 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation editRequirement($data: RequirementInput!) {\n        editRequirement(data: $data) {\n            id\n        }\n    }\n"])));
var TOGGLE_REQUIREMENT_ACTIVE_STATE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject27 || (_templateObject27 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation editRequirement($id: ID!, $is_active: Boolean!) {\n        toggleRequirementActiveState(id: $id, is_active: $is_active) {\n            id\n            is_active\n        }\n    }\n"])));
var APPLY_OPENING = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject28 || (_templateObject28 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation applyOpening($requirement_id: ID!) {\n        requirementApplication(requirement_id: $requirement_id) {\n            id\n            name\n            has_logged_in_user_applied\n        }\n    }\n"])));
var STORE_CANDIDATE_FEEDBACK_STATUS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject29 || (_templateObject29 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation storeCandidateFeedback($data: CandidateFeedbackInput!) {\n        storeCandidateFeedback(data: $data) {\n            status\n            comments\n        }\n    }\n"])));
var UPDATE_CANDIDATE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject30 || (_templateObject30 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation updateCandidate($id: ID!, $data: CandidateUpdateInput!) {\n        updateCandidate(id: $id, data: $data) {\n            id\n            has_references_requested\n        }\n    }\n"])));
var INITIATE_CALL = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject31 || (_templateObject31 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation initiateCall($data: InitiateCallInput!) {\n        initiateCall(data: $data)\n    }\n"])));
var UPDATE_CANDIDATE_FEEDBACK_STATUS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject32 || (_templateObject32 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation updateCandidateFeedback(\n        $id: ID!\n        $data: CandidateFeedbackUpdateInput!\n    ) {\n        updateCandidateFeedback(id: $id, data: $data) {\n            id\n            comments\n            status\n            acceptance_status\n        }\n    }\n"])));
var TOGGLE_USER_ACTIVE_STATE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject33 || (_templateObject33 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation updateUser($id: ID!, $data: UserUpdateInput!) {\n        updateUser(id: $id, data: $data) {\n            id\n            is_active\n        }\n    }\n"])));
var UNLOCK_CANDIDATE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject34 || (_templateObject34 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation unlockCandidate($candidate_uuid: String!) {\n        unlockCandidate(candidate_uuid: $candidate_uuid) {\n            candidate {\n                id\n                uuid\n                pii {\n                    name\n                    email\n                    phone\n                }\n                pii_docs {\n                    resume\n                    resume_url\n                    resume_mime\n                }\n                created_at\n                years_of_experience\n                notice_period\n                notice_period_status\n                current_compensation\n                expected_compensation\n                remaining_notice_period\n                applied_for\n                work_preferences\n                challenging_work\n                worklife_goals\n                reason_for_change\n                requires_unlocking\n                gravatar\n                screening_status\n                screening_notes\n                rejection_reasons\n                previous {\n                    status\n                    all\n                }\n                next {\n                    status\n                    all\n                }\n                async_video_intro_link\n                openings {\n                    name\n                }\n                city {\n                    id\n                    name\n                }\n                country {\n                    id\n                    name\n                    currency\n                }\n                interviews {\n                    id\n                    duration\n                    scheduler {\n                        id\n                        organization {\n                            id\n                        }\n                    }\n                    interview_details(candidate_uuid: $candidate_uuid) {\n                        insight_group_collection\n                        recording_urls\n                        scores\n                        skill_scores\n                        short_recording_urls\n                        strengths\n                        weaknesses\n                        locked\n                        details_pending\n                        transcript_analysis\n                        transcript_urls\n                        recommendation\n                        has_hire_recommendation\n                        has_no_hire_recommendation\n                    }\n                    interviewer {\n                        id\n                        name\n                        email\n                        interview_count\n                        about_me\n                        profile_picture\n                        organization {\n                            id\n                        }\n                    }\n                    participant {\n                        id\n                        name\n                    }\n                    start_time\n                    interview_type {\n                        id\n                        name\n                    }\n                    skills {\n                        name\n                    }\n                    started_at\n                    meeting_url\n                    invalidation_reasons\n                }\n                skills {\n                    id\n                    name\n                    pivot {\n                        years_of_experience\n                    }\n                }\n                meta {\n                    type\n                    key\n                    value\n                }\n                requirements {\n                    id\n                    name\n                }\n                feedbacks {\n                    user {\n                        id\n                        name\n                    }\n                    requirement {\n                        id\n                        name\n                    }\n                    status\n                    comments\n                }\n            }\n            organization {\n                id\n                name\n                logo\n                credits_remaining\n            }\n            response {\n                success\n                message\n            }\n        }\n    }\n"])));
var userDataWithParsedResume = "\n                id\n                name\n                email\n                years_of_experience\n                notice_period\n                notice_period_status\n                current_compensation\n                expected_compensation\n                resume_url\n                resume_mime\n                parsed_resume_details\n                skills {\n                    name\n                    pivot {\n                        years_of_experience\n                    }\n                }\n            ";
var UPDATE_USER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject35 || (_templateObject35 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation updateUser($id: ID!, $data: UserUpdateInput!) {\n        updateUser(id: $id, data: $data) {\n            id\n            name\n            email\n            phone\n            years_of_experience\n            notice_period\n            notice_period_status\n            current_compensation\n            expected_compensation\n            english_proficiency_level\n            availability_status\n            preferred_pronoun\n            resume_url\n            resume_mime\n            organization {\n                id\n                name\n                country {\n                    id\n                    name\n                }\n            }\n            skills {\n                id\n                name\n                user_pivot {\n                    years_of_experience\n                    rating\n                }\n            }\n            country {\n                id\n                name\n            }\n            city {\n                id\n                name\n            }\n            timezone\n            is_email_change_requested\n        }\n    }\n"])));
var UPDATE_ORGANIZATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject36 || (_templateObject36 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation updateOrganization($id: ID!, $data: OrganizationUpdateInput!) {\n        updateOrganization(id: $id, data: $data) {\n            id\n            name\n            logo\n            brand_color\n        }\n    }\n"])));
var UPDATE_USER_WITH_PARSED_DETAILS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject37 || (_templateObject37 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation updateUser($id: ID!, $data: UserUpdateInput!) {\n        updateUser(id: $id, data: $data) {\n            ", "\n        }\n    }\n"])), userDataWithParsedResume);
var CREATE_USER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject38 || (_templateObject38 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation createUser($data: UserCreateInput!) {\n        createUser(data: $data) {\n            id\n            name\n        }\n    }\n"])));
var SHARE_ENGINEER_PROFILE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject39 || (_templateObject39 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation shareEngineerProfile($data: ShareEngineerProfileInput!) {\n        shareEngineerProfile(data: $data) {\n            link\n        }\n    }\n"])));
var SAVE_SHARED_ENGINEER_PROFILE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject40 || (_templateObject40 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation saveSharedEngineerProfile($code: String!) {\n        saveSharedEngineerProfile(code: $code) {\n            id\n            uuid\n            skills {\n                id\n                name\n            }\n        }\n    }\n"])));
var multipleRequirementData = "id\n                uuid\n                name\n                open\n                is_active\n                organization {\n                    name\n                    logo\n                }\n                country {\n                    name\n                }\n                city {\n                    name\n                }\n                skills {\n                    name\n                    skill_pivot {\n                        is_mandatory\n                    }\n                }\n                is_public\n                seniority\n                has_logged_in_user_applied\n                created_at\n                all_candidates_count\n                work_place";
var singleRequirementData = "id\n                uuid\n                name\n                open\n                notice_period_preference\n                is_active\n                responsibilities\n                qualifications\n                budget_currency\n                budget_from\n                budget_to\n                organization {\n                    name\n                    logo\n                }\n                country {\n                    id\n                    name\n                }\n                city {\n                    id\n                    name\n                }\n                skills {\n                    id\n                    name\n                    skill_pivot {\n                        is_mandatory\n                    }\n                }\n                work_place\n                is_public\n                seniority\n                has_logged_in_user_applied\n                created_at\n                all_candidates_count";
var requirementData = "data {\n                ".concat(multipleRequirementData, "\n            }\n            paginatorInfo {\n                count\n                currentPage\n                firstItem\n                hasMorePages\n                lastItem\n                lastPage\n                total\n            }");
var GET_REQUIREMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject41 || (_templateObject41 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getRequirement($uuid: String!) {\n        requirement(uuid: $uuid) {\n            ", "\n        }\n    }\n"])), singleRequirementData);
var GET_REQUIREMENTS_QUERY = function GET_REQUIREMENTS_QUERY(auth, countryFilter, countryFilterHasAnywhere, skillFilter, seniorityFilter, workPlaceFilter) {
  var queryName = "requirements";
  return gql(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n        query getRequirements(\n            $active: Boolean\n            $is_public: Boolean\n            $first: Int!\n            $page: Int!\n            $searchName: Mixed\n            ", "\n            ", "\n            ", "\n            ", "\n        ) {\n            ", "(\n            is_active: $active\n            is_public: $is_public\n            first: $first\n            page: $page\n            where: {\n            AND: [\n                { column: NAME, operator: ILIKE, value: $searchName }\n                ", "\n                ", "\n                ", "\n            ]\n        }\n            ", "\n            ) {\n            ", "\n        }\n        }\n    "])), skillFilter ? "$skill_ids: Mixed" : "", countryFilter ? "$country_ids: Mixed" : "", seniorityFilter ? "$seniority: Mixed" : "", workPlaceFilter ? "$work_places: Mixed" : "", queryName, countryFilter ? countryFilterHasAnywhere ? "{ OR: [{ column: COUNTRY_ID, operator: IN, value: $country_ids }, { column: COUNTRY_ID, operator: IS_NULL }] }" : "{ column: COUNTRY_ID, operator: IN, value: $country_ids }" : "", seniorityFilter ? "{ column: SENIORITY, operator: IN, value: $seniority }" : "", workPlaceFilter ? "{ column: WORK_PLACE, operator: IN, value: $work_places }" : "", skillFilter ? "hasSkills: { column: ID, operator: IN, value: $skill_ids }" : "", requirementData);
};
var GET_REQUIREMENTS_BY_ACTIVE_STATE = function GET_REQUIREMENTS_BY_ACTIVE_STATE(searchName) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject43 || (_templateObject43 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getRequirements(\n        $active: Boolean\n        $first: Int!\n        $page: Int!\n        $hasSkills: [ID]\n        ", "\n    ) {\n        requirements(\n            is_active: $active\n            first: $first\n            page: $page\n            hasSkills: $hasSkills\n            where: {\n                OR: [\n                    ", "\n\n                ]\n            }\n        ) {\n            ", "\n        }\n    }\n"])), searchName ? "$searchName: Mixed" : "", searchName ? "{ column: NAME, operator: ILIKE, value: $searchName }" : "", requirementData);
};
var GET_ALL_SKILLS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject44 || (_templateObject44 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getAllSkills($allow_self_scheduling: Mixed) {\n        allSkills(\n            where: {\n                AND: [\n                    {\n                        column: ALLOW_SELF_SCHEDULING\n                        operator: IN\n                        value: $allow_self_scheduling\n                    }\n                ]\n            }\n        ) {\n            id\n            name\n        }\n    }\n"])));
var GET_ALL_REQUIREMENTS = function GET_ALL_REQUIREMENTS(searchName) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject45 || (_templateObject45 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getAllRequirements", " {\n        allRequirements(\n            where: {\n                OR: [", "]\n            }\n        ) {\n            id\n            name\n            skills {\n                name\n            }\n            open\n            country {\n                name\n            }\n            city {\n                name\n            }\n            organization {\n                id\n                name\n            }\n        }\n    }\n"])), searchName ? "($searchName: Mixed)" : "", searchName ? "{ column: NAME, operator: ILIKE, value: $searchName }" : "");
};
var GET_ALL_FILTERED_REQUIREMENTS = function GET_ALL_FILTERED_REQUIREMENTS(search) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject46 || (_templateObject46 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\nquery getAllRequirements", " {\n        allRequirements\n            ", "\n          {\n            id\n            name\n            is_active\n            skills {\n                name\n            }\n            open\n            country {\n                name\n            }\n            city {\n                name\n            }\n            organization {\n                id\n                name\n            }\n        }\n    }\n"])), search ? "($search: String)" : "", search ? "(search: $search)" : "");
};
var GET_ALL_CANDIDATE_REQUIREMENTS = function GET_ALL_CANDIDATE_REQUIREMENTS(search) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject47 || (_templateObject47 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\nquery getAllRequirements", " {\n        allRequirements\n            ", "\n          {\n            id\n            name\n            organization {\n                id\n                name\n            }\n        }\n    }\n"])), search ? "($search: String)" : "", search ? "(search: $search)" : "");
};
var GET_ALL_ACTIVE_REQUIREMENTS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject48 || (_templateObject48 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getAllActiveRequirements {\n        allRequirements(is_active: true) {\n            id\n            name\n            organization {\n                name\n            }\n        }\n    }\n"])));
var GET_ALL_COUNTRIES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject49 || (_templateObject49 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getAllCountries {\n        allCountries {\n            id\n            name\n            currency\n            currency_suffix\n        }\n    }\n"])));
var GET_CITIES_VIA_COUNTRY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject50 || (_templateObject50 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCitiesViaCountry($id: ID!) {\n        country(id: $id) {\n            id\n            name\n            cities {\n                id\n                name\n            }\n        }\n    }\n"])));
var ORG_INTERVIEW_TYPES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject51 || (_templateObject51 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query interviewTypes(\n        $allow_self_scheduling: Boolean\n        $organization_id: String\n    ) {\n        orgInterviewTypes(\n            allow_self_scheduling: $allow_self_scheduling\n            organization_id: $organization_id\n        ) {\n            id\n            name\n        }\n    }\n"])));
var ORG_INTERVIEWER_SLOTS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject52 || (_templateObject52 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query orgInterviewSlots($date: Date!, $skills: [Int!]!) {\n        orgInterviewSlots(date: $date, skills: $skills) {\n            id\n            user_id\n            start\n            end\n            disabled\n        }\n    }\n"])));
var SCHEDULE_INTERVIEW = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject53 || (_templateObject53 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation scheduleInterview($data: InterviewInput!) {\n        scheduleInterview(data: $data) {\n            id\n        }\n    }\n"])));
var SCHEDULE_CANDIDATE_INTERVIEW = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject54 || (_templateObject54 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation scheduleCandidateInterview($data: InterviewInput!) {\n        scheduleCandidateInterview(data: $data) {\n            id\n        }\n    }\n"])));
var RESCHEDULE_INTERVIEW = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject55 || (_templateObject55 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation editInterview($id: ID!, $data: InterviewInput!) {\n        editInterview(id: $id, data: $data) {\n            id\n            duration\n            scheduler {\n                id\n                organization {\n                    id\n                }\n            }\n            interview_details {\n                insight_group_collection\n                recording_urls\n                scores\n                skill_scores\n                short_recording_urls\n                strengths\n                weaknesses\n                locked\n                details_pending\n                transcript_analysis\n                transcript_urls\n                recommendation\n                score\n                has_hire_recommendation\n                has_no_hire_recommendation\n            }\n            interviewer {\n                id\n                name\n                email\n                interview_count\n                organization {\n                    id\n                }\n            }\n            participant {\n                id\n                name\n            }\n            start_time\n            interview_type {\n                id\n                name\n            }\n            skills {\n                id\n                name\n            }\n            started_at\n            meeting_url\n            invalidation_reasons\n        }\n    }\n"])));
var REMOVE_RESUME = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject56 || (_templateObject56 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation removeResume {\n        removeResume {\n            id\n        }\n    }\n"])));
var SEND_EMAIL_VERIFICATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject57 || (_templateObject57 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation sendVerificationEmail {\n        sendVerificationEmail {\n            id\n        }\n    }\n"])));
var REQUEST_EMAIL_CHANGE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject58 || (_templateObject58 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation requestEmailChange($data: RequestEmailChangeInput!) {\n        requestEmailChange(data: $data) {\n            user {\n                id\n                is_email_change_requested\n            }\n            response {\n                success\n                message\n            }\n        }\n    }\n"])));
var GET_DASHBOARD_CANDIDATE_STATISTICS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject59 || (_templateObject59 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getDashboardCandidateStatistics {\n        candidateStatistics {\n            total_candidates\n            new_candidates\n            shortlisted_candidates\n            hired_candidates\n            rejected_candidates\n            screened_candidates\n            interviewed_candidates\n        }\n    }\n"])));
var GET_DASHBOARD_REQUIREMENTS_CHART_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject60 || (_templateObject60 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getDashboardRequirementsChartData($limit: Int, $is_active: Boolean) {\n        limitedRequirements(\n            limit: $limit\n            is_active: $is_active\n            hasCandidates: {}\n        ) {\n            id\n            name\n            is_active\n            all_candidates_count\n            new_candidates_count\n            rejected_candidates_count\n            shortlisted_candidates_count\n            hired_candidates_count\n            screened_candidates_count\n            interviewed_candidates_count\n        }\n    }\n"])));
var GET_DASHBOARD_REQUIREMENT_COUNT_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject61 || (_templateObject61 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getDashboardRequirementCountData {\n        allRequirementsCount {\n            active\n            inactive\n        }\n    }\n"])));
var GET_CREATE_REQUIREMENT_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject62 || (_templateObject62 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCreateRequirementData {\n        allSkills {\n            id\n            name\n        }\n        allCountries {\n            id\n            name\n            currency\n            currency_suffix\n        }\n    }\n"])));
var GET_CANDIDATE_FEEDBACKS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject63 || (_templateObject63 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidateFeedbacks(\n        $uuid: Mixed!\n        $first: Int!\n        $page: Int!\n        $status: Mixed\n        $acceptance_status: Mixed\n    ) {\n        candidateFeedbacks(\n            hasCandidates: { column: UUID, operator: IN, value: $uuid }\n            first: $first\n            page: $page\n            where: {\n                AND: [\n                    { column: STATUS, operator: EQ, value: $status }\n                    {\n                        column: ACCEPTANCE_STATUS\n                        operator: IN\n                        value: $acceptance_status\n                    }\n                ]\n            }\n        ) {\n            data {\n                id\n                requirement {\n                    name\n                    organization {\n                        name\n                    }\n                }\n                status\n                acceptance_status\n                compensation_details_string\n            }\n            paginatorInfo {\n                count\n                currentPage\n                firstItem\n                hasMorePages\n                lastItem\n                lastPage\n                total\n            }\n        }\n    }\n"])));
var GET_EDIT_REQUIREMENT_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject64 || (_templateObject64 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getEditRequirementData($uuid: String!) {\n        requirement(uuid: $uuid) {\n            id\n            name\n            open\n            notice_period_preference\n            responsibilities\n            qualifications\n            notes_for_interviewers\n            budget_currency\n            budget_from\n            budget_to\n            is_active\n            seniority\n            work_place\n            country {\n                id\n                name\n                currency\n                currency_suffix\n            }\n            city {\n                id\n                name\n            }\n            skills {\n                id\n                name\n                skill_pivot {\n                    is_mandatory\n                }\n            }\n            is_public\n            has_recommendations_enabled\n            reviewers {\n                id\n                name\n                email\n            }\n            organization {\n                id\n            }\n        }\n        allSkills {\n            id\n            name\n        }\n        allCountries {\n            id\n            name\n            currency\n            currency_suffix\n        }\n    }\n"])));
var GET_CANDIDATE_LIST_DATA = function GET_CANDIDATE_LIST_DATA(searchName, searchType) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject65 || (_templateObject65 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidateListData", " {\n        allRequirements(\n            where: {\n                OR: [", "]\n            }\n        ) {\n            id\n            name\n            organization {\n                id\n                name\n            }\n            skills {\n                name\n            }\n            open\n            country {\n                name\n            }\n            city {\n                name\n            }\n        }\n    }\n"])), searchName && searchType ? "($searchName: Mixed)" : "", searchName ? searchType === "ID" ? "{ column: ID, operator: ILIKE, value: $searchName }" : "{ column: NAME, operator: ILIKE, value: $searchName }" : "");
};
var GET_CANDIDATE_REQUIREMENT_LIST_DATA = function GET_CANDIDATE_REQUIREMENT_LIST_DATA(searchType, search) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject66 || (_templateObject66 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidateListData", " {\n        allRequirements\n            ", "\n         {\n            id\n            name\n            organization {\n                id\n                name\n            }\n            skills {\n                name\n            }\n            open\n            country {\n                name\n            }\n            city {\n                name\n            }\n        }\n    }\n"])), search && searchType ? "($search: String)" : "", search ? "(search: $search)" : "");
};
var GET_CANDIDATE_SKILL_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject67 || (_templateObject67 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidateListData {\n        allSkills {\n            id\n            name\n        }\n    }\n"])));
var GET_CANDIDATE_STATIC_DATA = function GET_CANDIDATE_STATIC_DATA() {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject68 || (_templateObject68 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidateCreateData {\n        allCountries {\n            id\n            name\n            currency\n            currency_suffix\n        }\n        allRequirements", " {\n            id\n            name\n            skills {\n                name\n            }\n            open\n            country {\n                name\n            }\n            city {\n                name\n            }\n            organization {\n                name\n            }\n        }\n        allSkills {\n            id\n            name\n        }\n        allIndustries {\n            id\n            name\n        }\n        candidateStaticOptions {\n            notice_period_statuses\n            workplace_preferences\n            experience_areas\n            communication\n            compensation_suffix_frequencies\n        }\n    }\n"])), "(is_active: true)");
};
var GET_CANDIDATE_CREATE_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject69 || (_templateObject69 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidateCreateData {\n        allCountries {\n            id\n            name\n            currency\n            currency_suffix\n        }\n        allRequirements(is_active: true) {\n            id\n            name\n            skills {\n                name\n            }\n            open\n            country {\n                name\n            }\n            city {\n                name\n            }\n        }\n        allSkills {\n            id\n            name\n        }\n        allIndustries {\n            id\n            name\n        }\n        candidateStaticOptions {\n            notice_period_statuses\n            workplace_preferences\n            experience_areas\n            communication\n            compensation_suffix_frequencies\n        }\n    }\n"])));
var GET_CANDIDATE_EDIT_STATIC_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject70 || (_templateObject70 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidateEditData {\n        allCountries {\n            id\n            name\n            currency\n            currency_suffix\n        }\n        allRequirements {\n            id\n            name\n            skills {\n                name\n            }\n            open\n            country {\n                name\n            }\n            city {\n                name\n            }\n        }\n        allSkills {\n            id\n            name\n        }\n        allIndustries {\n            id\n            name\n        }\n        candidateStaticOptions {\n            notice_period_statuses\n            workplace_preferences\n            experience_areas\n            communication\n            compensation_suffix_frequencies\n        }\n    }\n"])));
var GET_CANDIDATE_EDIT_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject71 || (_templateObject71 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidateEditData($uuid: String!) {\n        candidate(uuid: $uuid) {\n            id\n            uuid\n            pii {\n                name\n                email\n                phone\n            }\n            pii_docs {\n                resume\n                resume_url\n                resume_mime\n            }\n            application_mode\n            created_at\n            remaining_notice_period\n            applied_for\n            work_preferences\n            challenging_work\n            worklife_goals\n            reason_for_change\n            gravatar\n            screening_status\n            skip_screening\n            city {\n                id\n                name\n            }\n            country {\n                id\n                name\n                currency\n            }\n            requirements {\n                id\n                name\n                organization {\n                    name\n                }\n            }\n            organization {\n                id\n            }\n            years_of_experience\n            years_of_remote_experience\n            notice_period\n            notice_period_status\n            last_working_day\n            current_compensation\n            expected_compensation\n            negotiable_compensation\n            negotiable_compensation_status\n            holding_compensation\n            github_username\n            work_place_preference\n            experience_areas\n            communication_screening\n            screening_notes\n            internal_notes\n            next_available_at_from\n            next_available_at_to\n            current_compensation_frequency\n            current_compensation_country_id\n            expected_compensation_frequency\n            expected_compensation_country_id\n            skills {\n                name\n                id\n                pivot {\n                    years_of_experience\n                }\n            }\n            industries {\n                name\n                id\n                pivot {\n                    years_of_experience\n                }\n            }\n        }\n    }\n"])));
var GET_PROFILE_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject72 || (_templateObject72 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getProfileData {\n        allCountries {\n            id\n            name\n            currency\n        }\n        allSkills {\n            id\n            name\n        }\n    }\n"])));
var VALIDATE_GOOGLE_TOKEN = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject73 || (_templateObject73 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation validateGoogleToken($data: GoogleTokenPayload!) {\n        validateGoogleToken(data: $data) {\n            is_valid\n            data\n            user_has_account\n            error\n        }\n    }\n"])));
var GET_INTERVIEW_QUESTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject74 || (_templateObject74 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query publicViewQuestion(\n        $interview_uuid: String!\n        $question_uuid: String!\n    ) {\n        publicViewQuestion(\n            interview_uuid: $interview_uuid\n            question_uuid: $question_uuid\n        ) {\n            interview {\n                id\n                interview_topic\n            }\n            expired\n            question {\n                id\n                question\n            }\n        }\n    }\n"])));
var GET_CLIENT_NOTIFICATION_TYPES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject75 || (_templateObject75 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query clientNotificationTypes {\n        clientNotificationTypes {\n            id\n            event\n            event_group\n        }\n    }\n"])));
var UPLOAD_AND_PARSE_RESUMES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject76 || (_templateObject76 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation uploadAndParseResumes($data: [String]!) {\n        uploadAndParseResumes(data: $data) {\n            name\n            email\n            phone\n            resume\n            resume_url\n            resume_mime\n            skills\n        }\n    }\n"])));
var CREATE_BULK_CANDIDATES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject77 || (_templateObject77 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation createBulkCandidates($data: [BulkCandidateInput]!) {\n        createBulkCandidates(data: $data) {\n            id\n        }\n    }\n"])));
var CLONE_REQUIREMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject78 || (_templateObject78 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation cloneRequirement($uuid: String!) {\n        cloneRequirement(uuid: $uuid) {\n            id\n            name\n            work_place\n        }\n    }\n"])));
var GET_ALL_REQUIREMENT_COUNT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject79 || (_templateObject79 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query allRequirementsCount {\n        allRequirementsCount {\n            active\n            inactive\n        }\n    }\n"])));
var GET_INTERVIEW_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject80 || (_templateObject80 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query interview($uuid: String!) {\n        interview(uuid: $uuid) {\n            data\n        }\n    }\n"])));
var GET_CALENDAR_INTERVIEWS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject81 || (_templateObject81 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query calendarInterviews(\n        $hasSkills: [ID]\n        $hasInterviewers: [ID]\n        $dateRange: DateRangeInput\n    ) {\n        calendarInterviews(\n            hasSkills: $hasSkills\n            hasInterviewers: $hasInterviewers\n            dateRange: $dateRange\n        ) {\n            id\n            duration\n            uuid\n            interview_topic\n            start_time\n            meeting_url\n            candidate {\n                uuid\n                pii {\n                    name\n                    email\n                    phone\n                }\n            }\n            interviewer {\n                name\n                linkedin_profile_url\n                email\n                phone\n            }\n            skills {\n                id\n                name\n                pivot {\n                    years_of_experience\n                }\n            }\n        }\n    }\n"])));
var PUBLISH_QUESTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject82 || (_templateObject82 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation publishQuestion($data: PublishQuestionInput!) {\n        publishQuestion(data: $data)\n    }\n"])));
var UPDATE_INTERVIEW_DETAILS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject83 || (_templateObject83 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation updateInterviewDetails($data: UpdateInterviewDetails!) {\n        updateInterviewDetails(data: $data)\n    }\n"])));
var DELETE_INTERVIEW_RECORDING = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject84 || (_templateObject84 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation clearInterviewRecording($data: ClearInterviewRecording!) {\n        clearInterviewRecording(data: $data)\n    }\n"])));
var GET_CANDIDATE_PII_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject85 || (_templateObject85 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getCandidate($uuid: String!) {\n        candidate(uuid: $uuid) {\n            id\n            uuid\n            pii {\n                name\n                email\n                phone\n            }\n            organization {\n                id\n                name\n            }\n            pii_docs {\n                resume\n                resume_url\n                resume_mime\n            }\n            github_username\n            linkedin_profile_url\n            requires_unlocking\n            gravatar\n            async_video_intro_link\n            city {\n                id\n                name\n            }\n            country {\n                id\n                name\n                currency\n            }\n        }\n    }\n"])));
var GET_QUESTIONS_LIST_DATA = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject86 || (_templateObject86 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getQuestionsListData {\n        allSkills {\n            id\n            name\n            questions_count\n        }\n    }\n"])));
var GET_ALL_QUESTIONS = function GET_ALL_QUESTIONS(skill_id, organization_id, question_group_id, is_published, difficulty) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject87 || (_templateObject87 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query allQuestions(\n        $first: Int!\n        $page: Int!\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n    ) {\n        allQuestions(\n            first: $first,\n            page: $page,\n            ", ",\n            ", ",\n            ", "\n            ", "\n            ", "\n        ) {\n            data {\n                id\n                uuid\n                question\n                answer\n                difficulty\n                skill {\n                    id\n                    name\n                }\n                organization {\n                    id\n                }\n                isPublished\n                questionGroup {\n                    id\n                    name\n                }\n                insights {\n                    id\n                    name\n                }\n            }\n            paginatorInfo {\n                count\n                currentPage\n                firstItem\n                hasMorePages\n                lastItem\n                lastPage\n                total\n            }\n        }\n    }\n"])), skill_id ? "$skill_id: ID" : "", organization_id ? "$organization_id: ID" : "", question_group_id ? "$question_group_id: ID" : "", is_published ? "$is_published: Mixed" : "", difficulty ? "$difficulty: QuestionDifficulty" : "", skill_id ? "skill_id: $skill_id" : "", organization_id ? "organization_id: $organization_id" : "", question_group_id ? "question_group_id: $question_group_id" : "", is_published ? "is_published: {AND: {column: USER_ID, operator: EQ, value: $is_published}}" : "", difficulty ? "difficulty: $difficulty" : "");
};
var GET_INSIGHTS_BY_QUESTION_TYPE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject88 || (_templateObject88 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query questionTypeInsights($question_type_id: ID) {\n        questionTypeInsights(question_type_id: $question_type_id) {\n            id\n            name\n            recommended\n        }\n    }\n"])));
var GET_QUESTION_GROUPS_BY_QUESTION_SKILL = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject89 || (_templateObject89 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query questionGroupsByQuestionSkill($skill_id: ID) {\n        questionGroupsByQuestionSkill(skill_id: $skill_id) {\n            id\n            name\n        }\n    }\n"])));
var SET_QUESTION_ASKED_AT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject90 || (_templateObject90 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation setAskedAt($data: SetAskedAtInput!) {\n        setAskedAt(data: $data)\n    }\n"])));
var GET_ALL_INTERVIEW_TYPES = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject91 || (_templateObject91 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query allInterviewTypes($organization_id: ID) {\n        allInterviewTypes(organization_id: $organization_id) {\n            id\n            name\n            insights_count\n        }\n    }\n"])));
var GET_ALL_INSIGHTS_PAGINATED = function GET_ALL_INSIGHTS_PAGINATED(interview_type_id, insight_group_id, organization_id) {
  return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject92 || (_templateObject92 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query paginatedInsights(\n        $first: Int!\n        $page: Int!\n        ", "\n        ", "\n    ) {\n        paginatedInsights(\n            first: $first,\n            page: $page,\n            ", ",\n            ", "\n        ) {\n            data {\n                id\n                name\n                is_active\n                type\n                description\n                options {\n                    id\n                    value\n                    description\n                }\n                interview_types {\n                    id\n                    name\n                }\n                insight_group {\n                    id\n                    name\n                }\n            }\n            paginatorInfo {\n                count\n                currentPage\n                firstItem\n                hasMorePages\n                lastItem\n                lastPage\n                total\n            }\n        }\n    }\n"])), interview_type_id ? "$interview_type_id: Mixed" : "", insight_group_id ? "$insight_group_id: ID" : "", interview_type_id ? "interview_type_id: { AND: [{column: INTERVIEW_TYPES_ID, value: $interview_type_id}{column: ORGANIZATION_ID, value: ".concat(organization_id, "}] }") : "", insight_group_id ? "insight_group_id: $insight_group_id" : "");
};
var GET_INSIGHT_GROUPS_BY_INTERVIEW_TYPE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject93 || (_templateObject93 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query insightGroupsByInterviewType($interview_type_id: ID) {\n        insightGroupsByInterviewType(interview_type_id: $interview_type_id) {\n            id\n            name\n        }\n    }\n"])));
var SHARE_CANDIDATE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject94 || (_templateObject94 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation shareCandidate($id: ID!, $data: ShareCandidateInput!) {\n        shareCandidate(id: $id, data: $data)\n    }\n"])));
var ADD_QUESTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject95 || (_templateObject95 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation createQuestion($data: QuestionInput!) {\n        createQuestion(data: $data) {\n            id\n        }\n    }\n"])));
var EDIT_QUESTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject96 || (_templateObject96 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation editQuestion($data: QuestionInput!) {\n        editQuestion(data: $data) {\n            id\n        }\n    }\n"])));
var CLONE_QUESTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject97 || (_templateObject97 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation cloneQuestion($id: String!) {\n        cloneQuestion(id: $id) {\n            id\n        }\n    }\n"])));
var GET_QUESTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject98 || (_templateObject98 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query question($id: ID) {\n        question(id: $id) {\n            id\n            question\n            answer\n            organization {\n                id\n            }\n            difficulty\n            skill {\n                id\n                name\n            }\n            isPublished\n            questionGroup {\n                id\n                name\n            }\n            insights {\n                id\n                name\n            }\n            questionType {\n                id\n            }\n            is_active\n            is_public\n        }\n    }\n"])));
var GET_ASYNC_MEET_ACCESS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject99 || (_templateObject99 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query getAsyncMeetAccessToken(\n        $api_key: String!\n        $email: String!\n        $organization_name: String!\n    ) {\n        getAsyncMeetAccessToken(\n            api_key: $api_key\n            email: $email\n            organization_name: $organization_name\n        ) {\n            has_access\n        }\n    }\n"])));
var GET_INTERVIEW_DESIGN = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject100 || (_templateObject100 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query interviewDesign($skill_ids: [ID!]!, $interview_type_id: ID!) {\n        interviewDesign(skill_ids: $skill_ids, interview_type_id: $interview_type_id) {\n            data\n        }\n    }\n"])));
var GET_SAMPLE_INTERVIEW_DESIGN = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject101 || (_templateObject101 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    query sampleInterviewDesign($uuid: String!) {\n        sampleInterviewDesign(uuid: $uuid) {\n            data\n        }\n    }\n"])));
var GENERATE_PRESIGNED_UPLOAD_URLS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_0__/* .gql */ .Ps)(_templateObject102 || (_templateObject102 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n    mutation GeneratePresignedUploadUrls($input: PresignedUploadRequestInput!) {\n        generatePresignedUploadUrls(input: $input) {\n            files {\n                filename\n                presigned_url\n            }\n        }\n    }\n"])));

/***/ }),

/***/ 66156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$x": function() { return /* binding */ uploadFilesToS3Batch; },
/* harmony export */   "AK": function() { return /* reexport safe */ _lightUtilities__WEBPACK_IMPORTED_MODULE_17__.AK; },
/* harmony export */   "Ac": function() { return /* binding */ getDefaultTimeZone; },
/* harmony export */   "BJ": function() { return /* binding */ formattedTime; },
/* harmony export */   "Bi": function() { return /* binding */ formattedDate; },
/* harmony export */   "CQ": function() { return /* binding */ getScreeningBgColor; },
/* harmony export */   "Ep": function() { return /* binding */ hasHtmlTags; },
/* harmony export */   "GC": function() { return /* binding */ passwordPatternIsValid; },
/* harmony export */   "Go": function() { return /* binding */ trimExtraSpaces; },
/* harmony export */   "Jm": function() { return /* binding */ getUserRoles; },
/* harmony export */   "N$": function() { return /* binding */ userHasPermission; },
/* harmony export */   "NP": function() { return /* binding */ userHasAnyRole; },
/* harmony export */   "Nv": function() { return /* binding */ filterCurrency; },
/* harmony export */   "OC": function() { return /* binding */ uploadFileToS3; },
/* harmony export */   "O_": function() { return /* binding */ getScoreBadgeColor; },
/* harmony export */   "PZ": function() { return /* binding */ isRedacted; },
/* harmony export */   "Pg": function() { return /* binding */ getHeader; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "Rr": function() { return /* binding */ preferredCitiesCheck; },
/* harmony export */   "U": function() { return /* binding */ renderMultiple; },
/* harmony export */   "U0": function() { return /* binding */ handleCopyWithNotificationRedux; },
/* harmony export */   "VP": function() { return /* binding */ recaptchaAPI; },
/* harmony export */   "W3": function() { return /* binding */ handleCopyWithNotification; },
/* harmony export */   "Yo": function() { return /* binding */ extractErrorMessage; },
/* harmony export */   "_E": function() { return /* binding */ filterCities; },
/* harmony export */   "_y": function() { return /* binding */ selectedTimeZone; },
/* harmony export */   "bo": function() { return /* binding */ getStaticColor; },
/* harmony export */   "br": function() { return /* binding */ extractDifficulty; },
/* harmony export */   "cN": function() { return /* binding */ getTabsIcon; },
/* harmony export */   "cz": function() { return /* binding */ replaceSpaceWithDash; },
/* harmony export */   "dv": function() { return /* binding */ getSkillRecommendationIcon; },
/* harmony export */   "eV": function() { return /* binding */ allowOnlyNumericCharacters; },
/* harmony export */   "f8": function() { return /* binding */ capitalizeFirstLetterOfAllWords; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "gA": function() { return /* binding */ replaceUnderscoreWithSpace; },
/* harmony export */   "g_": function() { return /* binding */ capitalizeFirstLetterOfAllTheWords; },
/* harmony export */   "gw": function() { return /* binding */ delay; },
/* harmony export */   "hE": function() { return /* binding */ deregisterAllServiceWorkers; },
/* harmony export */   "he": function() { return /* binding */ returnIfExists; },
/* harmony export */   "iA": function() { return /* binding */ customReactSelectErrorStyles; },
/* harmony export */   "jr": function() { return /* binding */ getModifiedValues; },
/* harmony export */   "ju": function() { return /* binding */ stripHtmlTags; },
/* harmony export */   "k6": function() { return /* binding */ CompensationSuffixFrequencies; },
/* harmony export */   "lq": function() { return /* binding */ teamMemberUpdateParser; },
/* harmony export */   "mD": function() { return /* binding */ getFileExtension; },
/* harmony export */   "mM": function() { return /* binding */ difficultyColorManager; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; },
/* harmony export */   "mh": function() { return /* binding */ calculateQuestionRecordingIndex; },
/* harmony export */   "mq": function() { return /* binding */ mimeIsDocType; },
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "nS": function() { return /* binding */ titleColor; },
/* harmony export */   "o0": function() { return /* binding */ generateQueryObject; },
/* harmony export */   "ot": function() { return /* binding */ getHashedValue; },
/* harmony export */   "p2": function() { return /* binding */ userHasRole; },
/* harmony export */   "q0": function() { return /* binding */ getNoticePeriod; },
/* harmony export */   "qt": function() { return /* binding */ userHasClientRole; },
/* harmony export */   "r_": function() { return /* binding */ siteCss; },
/* harmony export */   "rc": function() { return /* binding */ makePlural; },
/* harmony export */   "sG": function() { return /* binding */ parseDate; },
/* harmony export */   "sI": function() { return /* binding */ uploadThroughAxios; },
/* harmony export */   "tQ": function() { return /* binding */ replaceSpaceWithUnderScore; },
/* harmony export */   "vY": function() { return /* binding */ customReactSelectStyles; },
/* harmony export */   "vh": function() { return /* binding */ emailChangeNotificationHandler; },
/* harmony export */   "wK": function() { return /* binding */ hex2rgb; },
/* harmony export */   "wh": function() { return /* binding */ convertToFormData; },
/* harmony export */   "wl": function() { return /* reexport safe */ _lightUtilities__WEBPACK_IMPORTED_MODULE_17__.wl; },
/* harmony export */   "xY": function() { return /* binding */ replaceUnderScoreWithDash; },
/* harmony export */   "xZ": function() { return /* binding */ userRole; },
/* harmony export */   "xd": function() { return /* binding */ checkNavItemConditions; },
/* harmony export */   "xk": function() { return /* binding */ CurrencyValue; },
/* harmony export */   "yT": function() { return /* binding */ getCookieDomain; },
/* harmony export */   "zW": function() { return /* binding */ toCamelCase; }
/* harmony export */ });
/* unused harmony exports getRequirementSlug, extractUuidFromEnd, arrayIntersection, inputReference, formatRequirementLocation, formatRequirementBudget, validateUuid, generatePresignedUrls, getQueryParameterWithSpecialCharacter, allowOnlyNumericSpaceHyphenDot, rolesParser */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(16835);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10288);
/* harmony import */ var _gql_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69980);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54830);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2962);
/* harmony import */ var moment_moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30381);
/* harmony import */ var moment_moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment_moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _services_slices_notificationSlice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98003);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(59417);
/* harmony import */ var _material_tailwind_react_components_Tooltip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44744);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59433);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(13792);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(23157);
/* harmony import */ var _components_Alert__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36529);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _lightUtilities__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(88658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85893);




var _excluded = ["currencyKey"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var getPageMetadata = function getPageMetadata(title, description, url, image, imageAlt) {
  var canonical = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var openGraphType = "website";
  var twitterHandler = "@tacnique";
  var twitterCardLargeContent = "summary_large_image";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_5__/* .NextSeo */ .PB, _objectSpread({
      title: title,
      description: description,
      openGraph: {
        title: title,
        description: description,
        type: openGraphType,
        images: [{
          url: image,
          alt: imageAlt
        }],
        url: url
      }
    }, canonical && {
      canonical: canonical
    })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("meta", {
        name: "twitter:card",
        content: twitterCardLargeContent
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("meta", {
        name: "twitter:title",
        content: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("meta", {
        name: "twitter:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("meta", {
        name: "twitter:image",
        content: image
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("meta", {
        name: "twitter:image:alt",
        content: imageAlt
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("meta", {
        name: "twitter:site",
        content: twitterHandler
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("meta", {
        name: "twitter:creator",
        content: twitterHandler
      })]
    })]
  });
};

var getHeader = function getHeader(path, headers) {
  var defaultTitle = "The Future of Tech Hiring | Tacnique's Virtual Interview Platform";
  var defaultDescription = "Revolutionize your tech hiring process with Tacnique's virtual interview platform. Streamline your hiring solutions and find top tech talent from anywhere.";
  var defaultDescription2 = "Revolutionize your tech hiring process with Tacnique's virtual interview platform. Streamline your tech hiring and find top tech talent from anywhere.";
  var defaultUrl = "https://tacnique.com" || 0;
  var defaultImage = "/home/problem-solving.png";
  var defaultImageAlt = "Outsource Your Tech Interviews Now with Tacnique";
  var canonical = "https://tacnique.com";

  if (path === "/") {
    var image = "/home/problem-solving.png";
    var imageAlt = "Get Benefits of Tech Hiring Platform";
    return getPageMetadata(defaultTitle, defaultDescription, defaultUrl, image, imageAlt);
  } else if (path === "/about") {
    var aboutTitle = "About Tacnique | Our Story and Mission";
    var aboutDescription = "Learn about our vision and mission at Tacnique. Our story of how we strive to revolutionize the job interview process for both employers and job seekers.";
    var _image = "/about/hero.svg";
    var _imageAlt = "Transform Tech Hiring With Impartial Interview Platform";
    return getPageMetadata(aboutTitle, aboutDescription, "".concat(defaultUrl, "/about"), _image, _imageAlt);
  } else if (path === "/signup") {
    var signupTitle = "Sign Up | Tacnique";
    var signupDescription = "Sign up for Tacnique and streamline your tech hiring or find relevant job offers.";
    var _image2 = "/women-smiling.png";
    var _imageAlt2 = "Signup and Access Tech Hiring Platform";
    return getPageMetadata(signupTitle, signupDescription, "".concat(defaultUrl, "/signup"), _image2, _imageAlt2);
  } else if (path === "/login") {
    var loginTitle = "Access Your Tacnique Account | Login Here";
    var loginDescription = "Log in to your Tacnique account to find relevant software engineers to staff your open roles or find new jobs.";
    var _image3 = "/women-smiling.png";
    var _imageAlt3 = "Login and Access Tech Hiring Platform";
    return getPageMetadata(loginTitle, loginDescription, "".concat(defaultUrl, "/login"), _image3, _imageAlt3);
  } else if (path === "/engineers") {
    var engineersTitle = "Virtual Interview Platform for Engineers | Tacnique";
    var engineersDescription = "Elevate job hunt with virtual interviews. Get AI-powered recommendations for job offers. One-Click Hire for seamless hiring.";
    var _image4 = "/home/hero-main-img-new.png";
    var _imageAlt4 = "Meet Cloud-based Hiring Platform";
    return getPageMetadata(engineersTitle, engineersDescription, "".concat(defaultUrl, "/engineers"), _image4, _imageAlt4);
  } else if (path === "/demo") {
    var demoTitle = "Tacnique's Demo | See Our Features In Action";
    var demoDescription = "Discover the future of tech hiring with Tacnique. Our cutting-edge platform helps you hire the right talent quickly and easily. Book a demo with us, today!";
    var _imageAlt5 = "Outsource Your Tech Interviews Now";
    return getPageMetadata(demoTitle, demoDescription, "".concat(defaultUrl, "/demo"), defaultImage, _imageAlt5);
  } else if (path === "/companies/outsource-tech-interview") {
    var outsourceTechInterviewTitle = "Transform Your Tech Hiring Process with Tech Interview Outsourcing";
    var outsourceTechInterviewDescription = "Embrace the future of tech hiring with Tech Interview Outsourcing. Enhance candidate experience, simplify logistics, and make data-driven decisions. Get started now!";
    var _image5 = "/home/hero-main-img.png";
    var _imageAlt6 = "Outsource Tech Interviews and Transform your Hiring";
    return getPageMetadata(outsourceTechInterviewTitle, outsourceTechInterviewDescription, "".concat(defaultUrl, "/companies/outsource-tech-interview"), _image5, _imageAlt6);
  } else if (path === "/companies/verified-talent-pool") {
    var verifiedTalentPoolTitle = "Access a Verified Talent Pool | Tacnique";
    var verifiedTalentPoolDescription = "Access a large pool of screened and pre-evaluated software engineers that are relevant to your open roles. Contact us Now!";
    var _image6 = "/home/hero-cls-main.png";
    var _imageAlt7 = "Get benefits of a Verified Talent Pool";
    return getPageMetadata(verifiedTalentPoolTitle, verifiedTalentPoolDescription, "".concat(defaultUrl, "/companies/verified-talent-pool"), _image6, _imageAlt7);
  } else if (path === "/terms-and-conditions") {
    var termsAndConditionsTitle = "Tacnique | Understanding Our Terms and Conditions";
    var termsAndConditionsDescription = "Learn about Tacnique's terms and conditions, including user responsibilities and rights. Understand our policies and how they protect your interests.";
    var _imageAlt8 = "Terms and Conditions to Follow";
    return getPageMetadata(termsAndConditionsTitle, termsAndConditionsDescription, "".concat(defaultUrl, "/terms-and-conditions"), defaultImage, _imageAlt8);
  } else if (path === "/privacy-policy") {
    var privacyPolicyTitle = "Tacnique | Privacy Policy and Rights Overview";
    var privacyPolicyDescription = "Privacy a priority at Tacnique. Discover your data protection rights and how we ensure secure information. Read our Privacy Policy now.";
    var _imageAlt9 = "Privacy Policy and Information Collected";
    return getPageMetadata(privacyPolicyTitle, privacyPolicyDescription, "".concat(defaultUrl, "/privacy-policy"), defaultImage, _imageAlt9);
  } else if (path === "/cookie-policy") {
    var cookiePolicyTitle = "Tacnique | Guide to Use of Website Cookies";
    var cookiePolicyDescription = "Our Cookie Policy outlines how Tacnique uses cookies to improve your browsing experience. Learn more about our privacy practices and cookie usage here.";
    var _imageAlt10 = "Cookie Policy to Read";
    return getPageMetadata(cookiePolicyTitle, cookiePolicyDescription, "".concat(defaultUrl, "/cookie-policy"), defaultImage, _imageAlt10);
  } else if (path === "/companies") {
    var companiesTitle = "Outsource Your Technical Interviews to Tacnique Today";
    var companiesDescription = "Build agile and accountable technology teams at blazing speed with the power of an AI-driven cloud hiring platform. Outsource your Tech Hiring today.";
    return getPageMetadata(companiesTitle, companiesDescription, "".concat(defaultUrl, "/companies"), defaultImage, defaultImageAlt, canonical);
  } else if (path === "/businesses") {
    var businessesTitle = "Outsource Your Technical Interviews to Tacnique Today";
    var businessesDescription = "Build agile and accountable technology teams at blazing speed with the power of an AI-driven cloud hiring platform. Outsource your Tech Hiring today.";
    return getPageMetadata(businessesTitle, businessesDescription, "".concat(defaultUrl, "/businesses"), defaultImage, defaultImageAlt, canonical);
  } else if (headers && headers.length) {
    var header = headers.join(" < ") + " | Tacnique";
    return getPageMetadata(header, defaultDescription2, "".concat(defaultUrl).concat(path), defaultImage, defaultImageAlt);
  } else {
    return getPageMetadata(defaultTitle, defaultDescription2, "".concat(defaultUrl).concat(path), defaultImage, defaultImageAlt);
  }
};
var replaceUnderscoreWithSpace = function replaceUnderscoreWithSpace(string) {
  var _string$replaceAll;

  return (_string$replaceAll = string === null || string === void 0 ? void 0 : string.replaceAll("_", " ")) !== null && _string$replaceAll !== void 0 ? _string$replaceAll : "";
};
var replaceUnderScoreWithDash = function replaceUnderScoreWithDash(string) {
  var _string$replaceAll2;

  return (_string$replaceAll2 = string === null || string === void 0 ? void 0 : string.replaceAll("_", "-")) !== null && _string$replaceAll2 !== void 0 ? _string$replaceAll2 : "";
};
var replaceSpaceWithDash = function replaceSpaceWithDash(string) {
  var _string$replaceAll3;

  return (_string$replaceAll3 = string === null || string === void 0 ? void 0 : string.replaceAll(" ", "-")) !== null && _string$replaceAll3 !== void 0 ? _string$replaceAll3 : "";
};
var replaceSpaceWithUnderScore = function replaceSpaceWithUnderScore(string) {
  var _string$replaceAll4;

  return (_string$replaceAll4 = string === null || string === void 0 ? void 0 : string.replaceAll(" ", "_")) !== null && _string$replaceAll4 !== void 0 ? _string$replaceAll4 : "";
};
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : "";
};
var capitalizeFirstLetterOfAllWords = function capitalizeFirstLetterOfAllWords(string) {
  var _string$toLowerCase$s, _string$toLowerCase, _string$toLowerCase$s2, _string$toLowerCase$s3;

  return (_string$toLowerCase$s = string === null || string === void 0 ? void 0 : (_string$toLowerCase = string.toLowerCase()) === null || _string$toLowerCase === void 0 ? void 0 : (_string$toLowerCase$s2 = _string$toLowerCase.split(" ")) === null || _string$toLowerCase$s2 === void 0 ? void 0 : (_string$toLowerCase$s3 = _string$toLowerCase$s2.map(function (word) {
    var _word$charAt;

    return (word === null || word === void 0 ? void 0 : (_word$charAt = word.charAt(0)) === null || _word$charAt === void 0 ? void 0 : _word$charAt.toUpperCase()) + (word === null || word === void 0 ? void 0 : word.substring(1));
  })) === null || _string$toLowerCase$s3 === void 0 ? void 0 : _string$toLowerCase$s3.join(" ")) !== null && _string$toLowerCase$s !== void 0 ? _string$toLowerCase$s : "";
};
var capitalizeFirstLetterOfAllTheWords = function capitalizeFirstLetterOfAllTheWords(str) {
  return str === null || str === void 0 ? void 0 : str.replace(/\b\w/g, function (_char) {
    return _char === null || _char === void 0 ? void 0 : _char.toUpperCase();
  });
};
var getRequirementSlug = function getRequirementSlug(_ref) {
  var name = _ref.name,
      country = _ref.country,
      city = _ref.city,
      organization = _ref.organization,
      work_place = _ref.work_place,
      uuid = _ref.uuid;
  var slug = [];

  if (organization) {
    slug.push(organization.name);
  }

  if (name) {
    slug.push(name);
  }

  if (country) {
    slug.push(country.name);
  }

  if (city) {
    slug.push(city.name);
  }

  if (work_place) {
    slug.push(replaceUnderscoreWithSpace(work_place));
  }

  if (uuid) {
    slug.push(uuid);
  }

  return replaceSpaceWithDash(slug.join("-").toLowerCase());
};
var extractUuidFromEnd = function extractUuidFromEnd(string) {
  return string.split("-").slice(-5).join("-");
};
var delay = function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
}();
var filterCurrency = function filterCurrency(value, countries, setCurrency, setCurrencySuffix) {
  var _filteredCountry$0$cu, _filteredCountry$, _filteredCountry$2;

  var filteredCountry = countries === null || countries === void 0 ? void 0 : countries.filter(function (country) {
    return country.id.toString() === value.toString();
  });
  setCurrency((_filteredCountry$0$cu = (_filteredCountry$ = filteredCountry[0]) === null || _filteredCountry$ === void 0 ? void 0 : _filteredCountry$.currency) !== null && _filteredCountry$0$cu !== void 0 ? _filteredCountry$0$cu : _constants__WEBPACK_IMPORTED_MODULE_2__/* .defaultCurrency */ .OM);
  setCurrencySuffix((_filteredCountry$2 = filteredCountry[0]) === null || _filteredCountry$2 === void 0 ? void 0 : _filteredCountry$2.currency_suffix);
};
var filterCities = function filterCities(query, cities) {
  var _cities$country$citie, _cities$country, _cities$country$citie2, _cities$country2, _cities$country2$citi;

  return query === "" ? (_cities$country$citie = cities === null || cities === void 0 ? void 0 : (_cities$country = cities.country) === null || _cities$country === void 0 ? void 0 : _cities$country.cities) !== null && _cities$country$citie !== void 0 ? _cities$country$citie : [] : (_cities$country$citie2 = cities === null || cities === void 0 ? void 0 : (_cities$country2 = cities.country) === null || _cities$country2 === void 0 ? void 0 : (_cities$country2$citi = _cities$country2.cities) === null || _cities$country2$citi === void 0 ? void 0 : _cities$country2$citi.filter(function (city) {
    return city.name.toLowerCase().includes(query.toLowerCase());
  })) !== null && _cities$country$citie2 !== void 0 ? _cities$country$citie2 : [];
};
var getScoreBadgeColor = function getScoreBadgeColor(value) {
  var rating, rating_text;
  value = value.toLowerCase();

  if (value === "exceptional") {
    rating = "bg-green-300";
    rating_text = "text-green-800";
  } else if (value === "above Average") {
    rating = "bg-green-100";
    rating_text = "text-green-800";
  } else if (value === "average") {
    rating = "bg-yellow-100";
    rating_text = "text-yellow-800";
  } else if (value === "below average") {
    rating = "bg-red-100";
    rating_text = "text-red-800";
  } else if (value === "unsatisfactory") {
    rating = "bg-red-300";
    rating_text = "text-red-800";
  } else {
    rating = "bg-green-100";
    rating_text = "text-green-800";
  }

  return {
    rating: rating,
    rating_text: rating_text
  };
};
var getHashedValue = function getHashedValue(string) {
  return Math.abs(string.split("").reduce(function (a, b) {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0));
};
var getStaticColor = function getStaticColor(string) {
  var _placeholderColors;

  return (_placeholderColors = _constants__WEBPACK_IMPORTED_MODULE_2__/* .placeholderColors */ .l_[getHashedValue(string) % _constants__WEBPACK_IMPORTED_MODULE_2__/* .placeholderColors.length */ .l_.length]) !== null && _placeholderColors !== void 0 ? _placeholderColors : "bg-primary-500";
};
var siteCss = function siteCss(element, property) {
  return window.getComputedStyle(element, null).getPropertyValue(property);
};
var getNoticePeriod = function getNoticePeriod(remainingNoticePeriod) {
  return remainingNoticePeriod > 0 ? "".concat(remainingNoticePeriod, " ").concat(remainingNoticePeriod === 1 ? "day" : "days") : "Immediate";
};
var trimExtraSpaces = function trimExtraSpaces(string) {
  return string.replace(/ +/g, " ").trim();
};
var getDefaultTimeZone = function getDefaultTimeZone() {
  var _Intl$DateTimeFormat$ = new Intl.DateTimeFormat("default").resolvedOptions(),
      timeZone = _Intl$DateTimeFormat$.timeZone;

  if (Object.keys(_constants__WEBPACK_IMPORTED_MODULE_2__/* .mappedTimeZones */ .S_).includes(timeZone)) {
    timeZone = _constants__WEBPACK_IMPORTED_MODULE_2__/* .mappedTimeZones */ .S_[timeZone];
  }

  return timeZone;
};
var arrayIntersection = function arrayIntersection(a, b) {
  return a.filter(function (item) {
    return b.includes(item);
  });
};
var userRole = function userRole(user) {
  var userIsCompany = false;
  var userIsEngineer = false;

  if (user) {
    var userRoles = user.roles.map(function (role) {
      return role.name;
    });
    userIsCompany = !!arrayIntersection(_constants__WEBPACK_IMPORTED_MODULE_2__/* .companyRoles */ .Tw, userRoles).length;
    userIsEngineer = !!arrayIntersection(_constants__WEBPACK_IMPORTED_MODULE_2__/* .engineerRoles */ .OV, userRoles).length;
  }

  return {
    userIsCompany: userIsCompany,
    userIsEngineer: userIsEngineer
  };
};
var getModifiedValues = function getModifiedValues(values, initialValues) {
  var modifiedValues = {};

  if (values) {
    Object.entries(values).forEach(function (entry) {
      var key = entry[0];
      var value = entry[1];

      if (value !== initialValues[key]) {
        modifiedValues[key] = value;
      }
    });
  }

  return Object.keys(modifiedValues);
};
var inputReference = function inputReference(input) {
  if (input) {
    setTimeout(function () {
      input.focus();
    }, 100);
  }
};
var getFileExtension = function getFileExtension(url) {
  return url === null || url === void 0 ? void 0 : url.split("?")[0].split(".").pop();
};
var emailChangeNotificationHandler = function emailChangeNotificationHandler(email_change) {
  switch (email_change) {
    case "true":
      return {
        message: "Email has been changed successfully!",
        type: "success"
      };

    case "false":
      return {
        message: "Request email change cannot be completed as the email is already in use!",
        type: "error"
      };

    case "expired":
    default:
      return {
        message: "Link expired, please try again!",
        type: "error"
      };
  }
};
var formatRequirementLocation = function formatRequirementLocation(country, city) {
  var _country$name;

  return "".concat((_country$name = country === null || country === void 0 ? void 0 : country.name) !== null && _country$name !== void 0 ? _country$name : "Worldwide").concat(city ? ", " + (city === null || city === void 0 ? void 0 : city.name) : "", " Office");
};
var formatRequirementBudget = function formatRequirementBudget(budget_from, budget_to, budget_currency) {
  return "".concat(budget_currency !== null && budget_currency !== void 0 ? budget_currency : "", " ").concat(budget_from !== null && budget_from !== void 0 ? budget_from : "N/A").concat(budget_from && budget_currency ? budget_currency === defaultCurrency ? "L" : "K" : "", " to ").concat(budget_to !== null && budget_to !== void 0 ? budget_to : "N/A").concat(budget_to && budget_currency ? budget_currency === defaultCurrency ? "L" : "K" : "");
};
var returnIfExists = function returnIfExists(data) {
  var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return data ? "".concat(data, " ").concat(append) : "N/A";
};
var validateUuid = function validateUuid(value) {
  return uuidValidationRegEx.test(value);
};
var customReactSelectStyles = {
  control: function control(styles, state) {
    return {
      fontSize: "14px",
      backgroundColor: "hsl(0, 0%, 100%)",
      borderColor: state !== null && state !== void 0 && state.isFocused ? "rgb(13 148 136)" : "hsl(0, 0%, 80%)",
      borderRadius: "5px",
      borderStyle: "solid",
      borderWidth: "1px",
      cursor: "default",
      display: "flex",
      height: "100%",
      flexWrap: "wrap",
      justifyContent: "space-between",
      minHeight: "38px",
      outline: "0!important",
      position: "relative",
      transition: "all 100ms",
      boxSizing: "border-box",
      "--tw-ring-opacity": "0.5",
      "--tw-ring-color": "rgb(139 198 206 / var(--tw-ring-opacity))",
      "--tw-border-opacity": "1",
      ":hover": {
        "--tw-ring-opacity": "0.5",
        "--tw-ring-color": "rgb(139 198 206 / var(--tw-ring-opacity))",
        "--tw-border-opacity": "1",
        borderColor: "rgb(92 176 186 / var(--tw-border-opacity))"
      }
    };
  },
  placeholder: function placeholder(styles) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      color: "hsl(0, 0%, 50%)",
      fontSize: "14px"
    });
  },
  multiValueRemove: function multiValueRemove() {
    return {
      color: "black",
      alignItems: "center",
      borderRadius: "2px",
      display: "flex",
      paddingLeft: "4px",
      paddingRight: "4px",
      boxSizing: "border-box",
      ":hover": {
        backgroundColor: "rgb(251 113 133)",
        colour: "black"
      }
    };
  },
  menuList: function menuList() {
    return {
      maxHeight: "300px",
      overflowY: "auto",
      paddingBottom: "4px",
      paddingTop: "4px",
      position: "relative",
      boxSizing: "border-box"
    };
  },
  input: function input() {
    return {
      width: "100%",
      gridArea: "1/1/2/3",
      color: "inherit",
      background: "0px center",
      opacity: "1",
      font: "inherit",
      minWidth: "2px",
      border: "0px",
      margin: "0px",
      outline: "0px",
      padding: "0px 0px 0px 2px",
      "input[type=text]": {
        "--tw-ring-color": "black",
        height: "1rem",
        minWidth: "0px !important",
        width: "100%",
        boxShadow: "none"
      }
    };
  },
  menu: function menu() {
    return {
      top: "100%",
      backgroundColor: "hsl(0, 0%, 100%)",
      borderRadius: "4px",
      boxShadow: "0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%)",
      marginBottom: "8px",
      marginTop: "8px",
      position: "absolute",
      width: "100%",
      zIndex: "999",
      boxSizing: "border-box"
    };
  },
  option: function option(style, state) {
    return {
      backgroundColor: "transparent",
      color: state.isDisabled ? "hsl(0, 0%, 80%)" : "inherit",
      cursor: "default",
      display: "block",
      fontSize: "14px",
      padding: "8px 12px",
      width: "100%",
      userSelect: "none",
      boxSizing: "border-box",
      ":hover": {
        backgroundColor: state.isDisabled ? "transparent" : "rgb(13 148 136)",
        color: state.isDisabled ? "hsl(0, 0%, 80%)" : "rgb(255 255 255)"
      }
    };
  }
};
var customReactSelectErrorStyles = {
  control: function control(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      borderColor: "red",
      boxShadow: "none",
      ":hover": {
        borderColor: "red",
        borderWidth: "1px"
      }
    });
  },
  option: function option(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      backgroundColor: "transparent",
      ":hover": {
        backgroundColor: "rgb(13 148 136)",
        color: "rgb(255 255 255)"
      }
    });
  },
  menu: function menu(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      zIndex: "999"
    });
  },
  placeholder: function placeholder(styles) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      color: "hsl(0, 0%, 50%)",
      fontSize: "14px"
    });
  },
  input: function input() {
    return {
      width: "100%",
      gridArea: "1/1/2/3",
      color: "inherit",
      background: "0px center",
      opacity: "1",
      font: "inherit",
      minWidth: "2px",
      border: "0px",
      margin: "0px",
      outline: "0px",
      padding: "0px",
      "input[type=text]": {
        "--tw-ring-color": "black",
        height: "1rem",
        minWidth: "0px !important",
        width: "100%",
        boxShadow: "none"
      }
    };
  }
};
var getScreeningBgColor = function getScreeningBgColor(screeningStatus) {
  if (["Passed Level 1", "Passed Level 2"].includes(screeningStatus)) {
    return "text-green-500";
  } else if (["Failed Level 1", "Failed Level 2"].includes(screeningStatus)) {
    return "text-red-400";
  } else {
    return "text-yellow-500";
  }
};
var parseDate = function parseDate(input) {
  return moment_moment__WEBPACK_IMPORTED_MODULE_6___default()(input, "YYYY-MM-DD hh:mm:ss");
};
var calculateQuestionRecordingIndex = function calculateQuestionRecordingIndex(recordingStartedAtValues, questionAskedAtTime) {
  var low = 0;
  var high = recordingStartedAtValues === null || recordingStartedAtValues === void 0 ? void 0 : recordingStartedAtValues.length;

  while (low < high) {
    var mid = low + high >>> 1;
    if (parseDate(recordingStartedAtValues[mid]) < parseDate(questionAskedAtTime)) low = mid + 1;else high = mid;
  }

  return Math.max(low - 1, 0);
};
var isRedacted = function isRedacted(value) {
  return value === _constants__WEBPACK_IMPORTED_MODULE_2__/* .redactedPlaceholder */ .gk;
};
var userHasClientRole = function userHasClientRole(roles) {
  return roles === null || roles === void 0 ? void 0 : roles.some(function (role) {
    return ["client-admin", "client"].includes(role.name);
  });
};
var hex2rgb = function hex2rgb(data) {
  return "rgb(".concat(data === null || data === void 0 ? void 0 : data.match(/\w\w/g).map(function (x) {
    return +"0x".concat(x);
  }), ",0.8)");
};
var titleColor = function titleColor(data) {
  var returnDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _hex2rgb$match$map = hex2rgb(data).match(/\d+/g).map(Number),
      _hex2rgb$match$map2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_hex2rgb$match$map, 3),
      r = _hex2rgb$match$map2[0],
      g = _hex2rgb$match$map2[1],
      b = _hex2rgb$match$map2[2];

  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#374151" : returnDefault ? data : "#ffffff";
};
var convertToFormData = function convertToFormData(props) {
  var formData = new FormData();
  Object.keys(props).map(function (key) {
    return formData.append(key, props[key]);
  });
  return formData;
}; // Helper function to generate presigned URLs for multiple files

var generatePresignedUrls = /*#__PURE__*/function () {
  var _ref2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(files) {
    var fileInputs, response, presignedFiles;
    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            fileInputs = files.map(function (file) {
              return {
                filename: "tmp/" + crypto.randomUUID() + "." + file.name.split(".").pop(),
                content_type: file.type
              };
            });
            _context.next = 4;
            return _apollo_client__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mutate */ .Z.mutate({
              mutation: _gql_constants__WEBPACK_IMPORTED_MODULE_3__/* .GENERATE_PRESIGNED_UPLOAD_URLS */ .VE,
              variables: {
                input: {
                  files: fileInputs
                }
              }
            });

          case 4:
            response = _context.sent;
            presignedFiles = response.data.generatePresignedUploadUrls.files;

            if (!(!presignedFiles || presignedFiles.length !== files.length)) {
              _context.next = 8;
              break;
            }

            throw new Error('Failed to generate presigned URLs for all files');

          case 8:
            return _context.abrupt("return", files.map(function (file, index) {
              return {
                file: file,
                presignedUrl: presignedFiles[index].presigned_url,
                filename: presignedFiles[index].filename,
                s3FileName: "vapor-webapp/".concat(presignedFiles[index].filename)
              };
            }));

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            console.error('Error generating presigned URLs:', _context.t0);
            return _context.abrupt("return", null);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function generatePresignedUrls(_x) {
    return _ref2.apply(this, arguments);
  };
}(); // Batch upload function for multiple files (returns presigned URLs without uploading)

var uploadFilesToS3Batch = /*#__PURE__*/function () {
  var _ref3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(files) {
    var isVideo,
        presignedData,
        uploadPromises,
        _args3 = arguments;
    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isVideo = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;
            _context3.next = 3;
            return generatePresignedUrls(files);

          case 3:
            presignedData = _context3.sent;

            if (presignedData) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", isVideo ? files.map(function (file) {
              return [null, file, null];
            }) : files.map(function () {
              return null;
            }));

          case 6:
            if (!isVideo) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", presignedData.map(function (_ref4) {
              var presignedUrl = _ref4.presignedUrl,
                  file = _ref4.file,
                  s3FileName = _ref4.s3FileName;
              return [presignedUrl, file, s3FileName];
            }));

          case 10:
            // For regular files, upload immediately and return s3FileNames
            uploadPromises = presignedData.map( /*#__PURE__*/function () {
              var _ref6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(_ref5) {
                var presignedUrl, file, s3FileName;
                return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        presignedUrl = _ref5.presignedUrl, file = _ref5.file, s3FileName = _ref5.s3FileName;
                        _context2.prev = 1;
                        _context2.next = 4;
                        return axios__WEBPACK_IMPORTED_MODULE_7___default().put(presignedUrl, file, {
                          headers: {
                            'Content-Type': file.type,
                            'x-amz-server-side-encryption': 'AES256'
                          }
                        });

                      case 4:
                        return _context2.abrupt("return", s3FileName);

                      case 7:
                        _context2.prev = 7;
                        _context2.t0 = _context2["catch"](1);
                        console.error('Error uploading file:', _context2.t0);
                        return _context2.abrupt("return", null);

                      case 11:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[1, 7]]);
              }));

              return function (_x3) {
                return _ref6.apply(this, arguments);
              };
            }());
            _context3.next = 13;
            return Promise.all(uploadPromises);

          case 13:
            return _context3.abrupt("return", _context3.sent);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function uploadFilesToS3Batch(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var uploadFileToS3 = /*#__PURE__*/function () {
  var _ref7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(file) {
    var isVideo,
        result,
        _args4 = arguments;
    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            isVideo = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
            _context4.next = 3;
            return uploadFilesToS3Batch([file], isVideo);

          case 3:
            result = _context4.sent;
            return _context4.abrupt("return", result ? result[0] : isVideo ? [null, file, null] : null);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function uploadFileToS3(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
var uploadThroughAxios = function uploadThroughAxios(s3URL, onProgress, file) {
  return axios__WEBPACK_IMPORTED_MODULE_7___default().put(s3URL, file, {
    headers: {
      "Content-Type": file.type
    },
    onUploadProgress: function onUploadProgress(progressEvent) {
      var progress = progressEvent.loaded && progressEvent.total ? Math.round(progressEvent.loaded * 100 / progressEvent.total) : 0;
      onProgress(progress);
    }
  });
};
var passwordPatternIsValid = function passwordPatternIsValid(password) {
  return !password || !password.includes(" ");
};
var getQueryParameterWithSpecialCharacter = function getQueryParameterWithSpecialCharacter(path, key) {
  if (path) {
    var _path$split = path.split("?"),
        _path$split2 = _slicedToArray(_path$split, 2),
        _path$split2$ = _path$split2[1],
        queryString = _path$split2$ === void 0 ? "" : _path$split2$;

    var queryObject = queryString.split("&").reduce(function (previous, current) {
      var _current$split = current.split("="),
          _current$split2 = _slicedToArray(_current$split, 2),
          key = _current$split2[0],
          value = _current$split2[1];

      previous.set(key, value);
      return previous;
    }, new Map());
    return queryObject.get(key) ? encodeURI(queryObject.get(key)) : null;
  } else {
    return null;
  }
};
var recaptchaAPI = /*#__PURE__*/function () {
  var _ref8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee5(token) {
    var response;
    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetch("/api/reCAPTCHA", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                token: token
              })
            });

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.json());

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function recaptchaAPI(_x5) {
    return _ref8.apply(this, arguments);
  };
}();
var preferredCitiesCheck = function preferredCitiesCheck(cities) {
  if (!cities) {
    return "";
  }

  var cityNames = cities.map(function (city) {
    return city.name;
  }).join(", ");
  var text = cities.length > 1 ? "Preferred Cities are" : "Preferred City is";
  return "<span class=\"text-gray-500\">".concat(text, " ").concat(cityNames, "</span>");
};
var getCookieDomain = function getCookieDomain() {
  var location =  true && window.location && window.location.hostname;
  return location !== null && location !== void 0 && location.includes("localhost") ? "localhost" : ".tacnique.com";
};
var isFunction = function isFunction(fn) {
  return fn && typeof fn === "function";
};
var allowOnlyNumericCharacters = function allowOnlyNumericCharacters(e) {
  return ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
};
var allowOnlyNumericSpaceHyphenDot = function allowOnlyNumericSpaceHyphenDot(e) {
  // Allow numbers, spaces, hyphens, dots, arrows, and Backspace
  if (!/[\d\s.-]/.test(e.key) && !/^Arrow(Up|Down|Left|Right)$/.test(e.key) && e.key !== "Backspace") {
    e.preventDefault();
  }
};
var extractErrorMessage = function extractErrorMessage(response) {
  var mutation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  try {
    var cleanedErrorMessage = response === null || response === void 0 ? void 0 : response.substring(response.indexOf(":") + 1);
    var jsonResponse = JSON.parse(cleanedErrorMessage);
    return mutation ? jsonResponse.response.errors : jsonResponse.response.errors[0].message;
  } catch (error) {
    console.error("Error parsing the response:", error);
    return null;
  }
};
var formattedDate = function formattedDate(date) {
  return moment_moment__WEBPACK_IMPORTED_MODULE_6___default()(date).format("YYYY-MM-DD");
};
var formattedTime = function formattedTime(date, withSeconds) {
  return moment_moment__WEBPACK_IMPORTED_MODULE_6___default()(date).format("HH:mm".concat(withSeconds ? ":ss" : ""));
};
var getUserRoles = function getUserRoles(defaultRoles, userRoles) {
  return defaultRoles.filter(function (defaultRole) {
    return userRoles.find(function (userRole) {
      return userRole.name === defaultRole.value;
    });
  });
};
var rolesParser = function rolesParser(values) {
  return values.map(function (_ref9) {
    var value = _ref9.value;
    return value.toUpperCase().replace("-", "_");
  });
};
var teamMemberUpdateParser = function teamMemberUpdateParser(values, isNew) {
  var commonData = {
    phone: values.phone,
    timezone: values.timezone,
    roles: (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, isNew ? "connect" : "sync", rolesParser(values.roles))
  };
  return isNew ? {
    data: _objectSpread(_objectSpread({}, commonData), {}, {
      name: values.name,
      email: values.email
    })
  } : {
    id: values.id,
    data: _objectSpread(_objectSpread({}, commonData), {}, {
      id: values.id
    })
  };
};
var selectedTimeZone = function selectedTimeZone(tzStrings, userTimeZone) {
  return tzStrings.filter(function (tzString) {
    return tzString["value"] === userTimeZone;
  }).map(function (tzString) {
    return {
      label: tzString.label,
      value: tzString.value
    };
  });
};
var handleCopyWithNotification = function handleCopyWithNotification(event, message, setNotification, value) {
  event.preventDefault();
  navigator.clipboard.writeText(value).then(function () {
    setNotification({
      message: message,
      type: "success"
    });
    setTimeout(function () {
      return setNotification(null);
    }, 5000);
  })["catch"](function () {
    setNotification({
      message: "Something went wrong!",
      type: "error"
    });
    setTimeout(function () {
      return setNotification(null);
    }, 5000);
  });
};
var handleCopyWithNotificationRedux = function handleCopyWithNotificationRedux(value, message) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "success";
  return function (dispatch) {
    navigator.clipboard.writeText(value).then(function () {
      dispatch((0,_services_slices_notificationSlice__WEBPACK_IMPORTED_MODULE_9__/* .setNotification */ .sc)({
        message: message,
        type: type
      }));
    })["catch"](function () {
      dispatch((0,_services_slices_notificationSlice__WEBPACK_IMPORTED_MODULE_9__/* .setNotification */ .sc)({
        message: "Something went wrong!",
        type: "error"
      }));
    });
  };
};
var difficultyColorManager = function difficultyColorManager(difficulty, property) {
  var includeDot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var difficultyColorMap = {
    EASY: "green-800 bg-green-100",
    0: "green-600",
    "EASY-dot": "green-800",
    EXCEPTIONAL: "green-600",
    1: "green-500",
    "ABOVE AVERAGE": "green-500",
    MEDIUM: "yellow-800 bg-yellow-100",
    2: "yellow-500",
    "MEDIUM-dot": "yellow-500",
    AVERAGE: "yellow-500",
    HARD: "red-800 bg-red-100",
    3: "red-500",
    "HARD-dot": "red-500",
    "BELOW AVERAGE": "red-500",
    "VERY HARD": "red-800 bg-red-100",
    VERY_HARD: "red-800 bg-red-100",
    "VERY HARD-dot": "red-800",
    4: "red-600",
    UNSATISFACTORY: "red-600"
  };
  var difficultyKey = includeDot ? "".concat(difficulty, "-dot") : difficulty;
  return "".concat(property, "-").concat(difficultyColorMap[difficultyKey] || "primary-700");
};
var makePlural = function makePlural(word) {
  return word !== null && word !== void 0 && word.endsWith("y") && !"aeiou".includes(word[word.length - 2]) ? "".concat(word.slice(0, -1), "ies") : "".concat(word, "s");
};
var getSkillRecommendationIcon = function getSkillRecommendationIcon(recommendation, values) {
  var icon,
      colour,
      message,
      rgb = "grey";

  switch (recommendation) {
    case "Hire":
      icon = _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faCheck */ .LEp;
      colour = "bg-green-500";
      rgb = "rgb(132 204 22)";
      message = "Recommended";
      break;

    case "Strong Hire":
      icon = _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faCheck */ .LEp;
      colour = "bg-green-500";
      rgb = "rgb(132 204 22)";
      message = "Strongly Recommended";
      break;

    case "No Hire":
      icon = _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faX */ .EOp;
      colour = "bg-red-500";
      rgb = "red";
      message = "Not Recommended";
      break;

    case "Strong No Hire":
      icon = _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faX */ .EOp;
      colour = "bg-red-500";
      rgb = "red";
      message = "Strongly Not Recommended";
      break;

    case null:
    default:
      icon = _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faExclamation */ .WV2;
      colour = "bg-yellow-500";
      rgb = "rgb(250 204 21)";
      message = "Recommendation Pending";
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_material_tailwind_react_components_Tooltip__WEBPACK_IMPORTED_MODULE_10__["default"], {
    content: message,
    children: values ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
      className: "relative sm_max:w-4/12 flex justify-center items-center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("svg", {
        className: "rotate-[-90deg]",
        width: 30,
        height: 30,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("circle", {
          className: "svg-circle-bg",
          stroke: "#ddd",
          cx: 15,
          cy: 15,
          r: 13.5,
          strokeWidth: 3
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("circle", {
          className: "svg-circle-bg",
          stroke: rgb,
          cx: 15,
          cy: 15,
          r: 13.5,
          strokeWidth: 3,
          strokeDasharray: 2 * Math.PI * 13.5,
          strokeDashoffset: (100 - values) / 100 * (2 * Math.PI * 13.5)
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
        "data-test-id": "candidate-score",
        className: "absolute text-center",
        style: {
          transform: "translate(-50%, -50%)",
          top: "50%",
          left: "50%",
          fontSize: "0.75rem" // Adjust font size for smaller component

        },
        children: values
      })]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
      className: (0,_lightUtilities__WEBPACK_IMPORTED_MODULE_17__/* .classNames */ .AK)("h-4 w-4 rounded-full flex items-center justify-center ring-8 ring-white text-white text-xs", colour),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_11__/* .FontAwesomeIcon */ .G, {
        icon: icon,
        className: "inline-block text-white",
        "aria-hidden": "true",
        size: "xs"
      })
    })
  });
};
var getTabsIcon = function getTabsIcon(value) {
  var icon, colour, message;

  switch (value) {
    case "summary":
      icon = _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faList */ .Zrf;
      colour = "bg-primary-500";
      message = "Summary";
      break;

    case "recordings":
      icon = _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faVideoCamera */ .iGN;
      colour = "bg-primary-500";
      message = "Recordings";
      break;

    case null:
    default:
      icon = _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_20__/* .faExclamation */ .WV2;
      colour = "bg-yellow-500";
      message = "Recommendation Pending";
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_material_tailwind_react_components_Tooltip__WEBPACK_IMPORTED_MODULE_10__["default"], {
    content: message,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
      className: (0,_lightUtilities__WEBPACK_IMPORTED_MODULE_17__/* .classNames */ .AK)("h-5 w-5 rounded-full flex items-center justify-center ring-8 ring-white", colour),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_11__/* .FontAwesomeIcon */ .G, {
        icon: icon,
        className: "inline-block text-white",
        "aria-hidden": "true",
        size: "xs"
      })
    })
  });
};
var isEmptyObject = function isEmptyObject(objectName) {
  return objectName && Object.keys(objectName).length === 0 && objectName.constructor === Object;
};
var checkNavItemConditions = function checkNavItemConditions(conditions, user) {
  return conditions.every(function (condition) {
    var _user$organization;

    switch (condition) {
      case "organization-has-interviewing-platform_access":
        return (_user$organization = user.organization) === null || _user$organization === void 0 ? void 0 : _user$organization.has_interviewing_platform_access;

      default:
        return true;
    }
  });
};
var hasHtmlTags = function hasHtmlTags(value) {
  var htmlRegex = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/g;
  return htmlRegex.test(value);
};
var userHasPermission = function userHasPermission(user, permission) {
  var _user$available_permi;

  return user === null || user === void 0 ? void 0 : (_user$available_permi = user.available_permissions) === null || _user$available_permi === void 0 ? void 0 : _user$available_permi.includes(permission);
};
var userHasRole = function userHasRole(user, roleToCheck) {
  var _user$roles;

  return user === null || user === void 0 ? void 0 : (_user$roles = user.roles) === null || _user$roles === void 0 ? void 0 : _user$roles.some(function (role) {
    return (role === null || role === void 0 ? void 0 : role.name) === roleToCheck;
  });
};
var userHasAnyRole = function userHasAnyRole(user, rolesToCheck) {
  return user.roles.some(function (role) {
    return rolesToCheck.includes(role === null || role === void 0 ? void 0 : role.name);
  });
};
var CurrencyValue = function CurrencyValue(_ref10) {
  var currencyKey = _ref10.currencyKey,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_ref10, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_22__.c.SingleValue, _objectSpread(_objectSpread({}, props), {}, {
    children: currencyKey ? props.data[currencyKey] : props.data.name
  }));
};
var CompensationSuffixFrequencies = function CompensationSuffixFrequencies(_ref11) {
  var name = _ref11.name,
      compensationFrequencyOptions = _ref11.compensationFrequencyOptions,
      FrequencyError = _ref11.FrequencyError;

  var selectedFrequency = function selectedFrequency(value) {
    return compensationFrequencyOptions === null || compensationFrequencyOptions === void 0 ? void 0 : compensationFrequencyOptions.find(function (item) {
      return value && item.value === value;
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(formik__WEBPACK_IMPORTED_MODULE_13__/* .Field */ .gN, {
    name: name,
    children: function children(_ref12) {
      var field = _ref12.field,
          form = _ref12.form;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP, {
          id: name,
          name: name,
          options: compensationFrequencyOptions,
          placeholder: "",
          components: {
            CurrencyValue: CurrencyValue
          },
          styles: form.errors[name] && form.touched[name] ? customReactSelectErrorStyles : customReactSelectStyles,
          value: selectedFrequency(field.value),
          getOptionLabel: function getOptionLabel(item) {
            return item.value;
          },
          getOptionValue: function getOptionValue(item) {
            return item.value;
          },
          onChange: function onChange(options) {
            form.setFieldValue(name, options.value);
          },
          "data-test-id": name
        }), FrequencyError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_Alert__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          message: FrequencyError
        })]
      });
    }
  });
};
var mimeIsDocType = function mimeIsDocType(mime) {
  return ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"].includes(mime);
};
var generateQueryObject = function generateQueryObject(keys) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)();
  var queryObject = {};
  keys === null || keys === void 0 ? void 0 : keys.forEach(function (key) {
    if (router !== null && router !== void 0 && router.query[key]) {
      queryObject[key] = router.query[key];
    }
  });
  return queryObject;
};
var renderMultiple = function renderMultiple(element, number) {
  return Array(number).fill(true).map(function (item, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
      children: element
    }, index);
  });
};
var extractDifficulty = function extractDifficulty(selected, options) {
  var parsedOptions = options.map(function (item, index) {
    return {
      label: capitalizeFirstLetter(replaceUnderscoreWithSpace(item)),
      value: replaceUnderscoreWithSpace(item),
      id: index
    };
  });
  var exist = selected ? parsedOptions.find(function (item) {
    return replaceUnderscoreWithSpace(item.value) === replaceUnderscoreWithSpace(selected);
  }) : null;
  return [exist, parsedOptions];
};
var formatTime = function formatTime(seconds) {
  var minutes = Math.floor(seconds / 60);
  var remainingSeconds = seconds % 60;
  return "".concat(String(minutes).padStart(2, "0"), ":").concat(String(remainingSeconds).padStart(2, "0"));
}; // Function to clear cached pages

var deregisterAllServiceWorkers = /*#__PURE__*/function () {
  var _ref13 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee6() {
    var registrations, _iterator, _step, registration, cacheNames, _iterator2, _step2, cacheName;

    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return navigator.serviceWorker.getRegistrations();

          case 3:
            registrations = _context6.sent;
            _iterator = _createForOfIteratorHelper(registrations);
            _context6.prev = 5;

            _iterator.s();

          case 7:
            if ((_step = _iterator.n()).done) {
              _context6.next = 13;
              break;
            }

            registration = _step.value;
            _context6.next = 11;
            return registration.unregister();

          case 11:
            _context6.next = 7;
            break;

          case 13:
            _context6.next = 18;
            break;

          case 15:
            _context6.prev = 15;
            _context6.t0 = _context6["catch"](5);

            _iterator.e(_context6.t0);

          case 18:
            _context6.prev = 18;

            _iterator.f();

            return _context6.finish(18);

          case 21:
            console.log("All service workers deregistered."); // Clear all caches

            _context6.next = 24;
            return caches.keys();

          case 24:
            cacheNames = _context6.sent;
            _iterator2 = _createForOfIteratorHelper(cacheNames);
            _context6.prev = 26;

            _iterator2.s();

          case 28:
            if ((_step2 = _iterator2.n()).done) {
              _context6.next = 34;
              break;
            }

            cacheName = _step2.value;
            _context6.next = 32;
            return caches["delete"](cacheName);

          case 32:
            _context6.next = 28;
            break;

          case 34:
            _context6.next = 39;
            break;

          case 36:
            _context6.prev = 36;
            _context6.t1 = _context6["catch"](26);

            _iterator2.e(_context6.t1);

          case 39:
            _context6.prev = 39;

            _iterator2.f();

            return _context6.finish(39);

          case 42:
            console.log("All caches cleared.");
            _context6.next = 48;
            break;

          case 45:
            _context6.prev = 45;
            _context6.t2 = _context6["catch"](0);
            console.error("Error deregistering service workers:", _context6.t2);

          case 48:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 45], [5, 15, 18, 21], [26, 36, 39, 42]]);
  }));

  return function deregisterAllServiceWorkers() {
    return _ref13.apply(this, arguments);
  };
}();
var toCamelCase = function toCamelCase(str) {
  return str.toLowerCase().split(" ").map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
};
var stripHtmlTags = function stripHtmlTags(html) {
  var div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

/***/ })

}]);